(function () {
  'use strict';

  angular
    .module('rpkspkRpk', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource',
      'ui.router', 'ui.bootstrap', 'toastr', 'satellizer', 'sn.skrollr', 'ncy-angular-breadcrumb', 'ngProgress',
      'ncy-angular-breadcrumb', 'mp.deepBlur', 'ngMap', 'vcRecaptcha']);
})();

'use strict';
angular
  .module('rpkspkRpk')
  .factory('UsuarioprodService', function ($http, $rootScope) {
    return {
      visualizarporproducto: function (id) {
        return $http.get($rootScope.api + '/api/usuariosproductos/visualizarporproducto/' + id);
      }
    };
  });

'use strict';

angular
        .module('rpkspkRpk')
        .factory('UsersService', function ($http, $rootScope) {
            return {
                all: function () {
                    return $http.get($rootScope.api + '/api/usuario');
                }
            };
        });

'use strict';
angular
  .module('rpkspkRpk')
  .factory('TablesService', function ($http, $rootScope) {
    return {
      listar: function (tabla) {
        return $http.get($rootScope.api + '/api/' + tabla);
      },
      visualizar: function (tabla, id) {
        return $http.get($rootScope.api + '/api/' + tabla + '/visualizar/' + id);
      },
      mapas: function () {
        return $http.post($rootScope.api + '/api/usuariosproductos/mapas');
      },
      buscar: function (parametros) {
        return $http.post($rootScope.api + '/api/buscarr', parametros);
      }
    };
  });

'use strict';
angular
        .module('rpkspkRpk')
        .factory('SinApiService', function ($http, $rootScope) {
            return {
                enviarMailContacto: function (parametros) {
                    return $http.post($rootScope.api + '/api/contactar', parametros);
                },
                enviarMailSolicitud: function (parametros) {
                    return $http.post($rootScope.api + '/api/solicitar', parametros);
                }
            };
        });

'use strict';
angular
        .module('rpkspkRpk')
        .factory('ProductService', function ($http, $rootScope) {
            return {
                listar: function () {
                    return $http.get($rootScope.api + '/api/productos');
                },
                visualizar: function (id) {
                    return $http.get($rootScope.api + '/api/productos/visualizar/' + id + '/?token=' + $rootScope.tk);
                },
                visualizarporciudad: function (id) {
                    return $http.get($rootScope.api + '/api/productos/visualizarporciudad/' + id);
                },
                almacenar: function (parametros) {
                    parametros['token'] = $rootScope.tk;
                    return $http.post($rootScope.api + '/api/productos/almacenar', parametros);
                },
                actualizar: function (id, parametros) {
                    parametros['token'] = $rootScope.tk;
                    return $http.put($rootScope.api + '/api/productos/actualizar/' + id, parametros);
                },
                eliminar: function (id) {
                    return $http.post($rootScope.api + '/api/productos/eliminar/' + id, {token: $rootScope.tk});
                },
                quitar: function (id) {
                    return $http.delete($rootScope.api + '/api/productos/quitar/' + id, {token: $rootScope.tk});
                },
                campos: function () {
                    return $http.get($rootScope.api + '/api/productos/campos/?token=' + $rootScope.tk);
                }
            };
        });

angular.module('rpkspkRpk')
  .factory('PreloaderImage', function ( $q, $rootScope) {
    function Preloader( imageLocations ) {
      this.imageLocations = imageLocations;
      this.imageCount = this.imageLocations.length;
      this.loadCount = 0;
      this.errorCount = 0;
      this.states = {
        PENDING: 1,
        LOADING: 2,
        RESOLVED: 3,
        REJECTED: 4
      };
      this.state = this.states.PENDING;
      this.deferred = $q.defer();
      this.promise = this.deferred.promise;
    }

    Preloader.preloadImages = function( imageLocations ) {
      var preloader = new Preloader( imageLocations );
      return( preloader.load() );
    };

    Preloader.prototype = {
      constructor: Preloader,
      isInitiated: function isInitiated() {
        return( this.state !== this.states.PENDING );
      },
      isRejected: function isRejected() {
        return( this.state === this.states.REJECTED );
      },
      isResolved: function isResolved() {
        return( this.state === this.states.RESOLVED );
      },
      load: function load() {
        if ( this.isInitiated() ) {
          return( this.promise );
        }
        this.state = this.states.LOADING;
        for ( var i = 0 ; i < this.imageCount ; i++ ) {
          this.loadImageLocation( this.imageLocations[ i ] );
        }
        return( this.promise );
      },
      handleImageError: function handleImageError( imageLocation ) {
        this.errorCount++;
        if ( this.isRejected() ) {
          return;
        }
        this.state = this.states.REJECTED;
        this.deferred.reject( imageLocation );
      },
      handleImageLoad: function handleImageLoad( imageLocation ) {
        this.loadCount++;
        if ( this.isRejected() ) {
          return;
        }

        this.deferred.notify({
          percent: Math.ceil( this.loadCount / this.imageCount * 100 ),
          imageLocation: imageLocation
        });
        if ( this.loadCount === this.imageCount ) {
          this.state = this.states.RESOLVED;
          this.deferred.resolve( this.imageLocations );
        }
      },
      loadImageLocation: function loadImageLocation( imageLocation ) {
        var preloader = this;
        var image = angular.element( new Image() )
            .load(
            function( event ) {
              $rootScope.$apply(
                function() {
                  preloader.handleImageLoad( event.target.src );
                  preloader = image = event = null;
                  image = image;
                }
              );
            }
          )
            .error(
            function( event ) {
              $rootScope.$apply(
                function() {
                  preloader.handleImageError( event.target.src );
                  preloader = image = event = null;
                }
              );
            }
          )
            .prop( 'src', imageLocation )
          ;
      }
    };
    return( Preloader );
  });

'use strict';

angular
        .module('rpkspkRpk')
        .factory('AuthService', function ($http, $rootScope, $log, $auth) {
            return {
                login: function (xemail, xpassword) {
                    var credentials = {
                        email: xemail,
                        password: xpassword
                    }
//                    var data = angular.element.param({
//                        email: xemail,
//                        password: xpassword
//                    });
                    var config = {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8;'
                        }
                    }
                    return $auth.login(credentials, config).then(function () {});
//                    return $http.post($rootScope.api + '/api/authenticate', data, config)
//                            .success(function () {
//                                $log.debug('login aceptado');
//                            })
//                            .error(function () {
//                                $log.debug('login denegado');
//                            });
                }
//                    logout: function () {
//                        return $http.post($rootScope.envUrl + '/logout/', {})
//                                .success(function () {
//                                    localStorageService.clearAll();
//                                    FlashService.show('Hasta pronto!', 'info');
//                                    $location.path('/ingresar');
//                                })
//                                .error(function (data) {
//                                    FlashService.show(data.message, 'danger', false);
//                                });
//                    },
//                    confirmNewPassword: function (password, uid, token) {
//                        return $http.post($rootScope.envUrl + '/password/reset/confirm/', {
//                            new_password: password,
//                            uid: uid,
//                            token: token
//                        })
//                                .success(function () {
//                                    $route.reload();
//                                });
//                    },
//                    activateAccount: function (uid, token) {
//                        return $http.post($rootScope.envUrl + '/activate/account/confirm/', {
//                            uid: uid,
//                            token: token
//                        })
//                                .success(function () {
//                                    $location.path('/ingresar');
//                                    FlashService.show('Su cuenta a sido activada, inicie sesión', 'success');
//                                })
//                                .error(function () {
//                                    FlashService.show('No se pudo activar la cuenta.', 'danger', false);
//                                });
//                    },
//                    sendEmailActivation: function (email) {
//                        return $http.post($rootScope.envUrl + '/activate/account/', {
//                            email: email
//                        })
//                                .success(function () {
//                                    FlashService.show('Se le ha enviado un correo con instrucciones para activar su cuenta', 'success');
//                                    $location.path('/registro/completado');
//                                })
//                                .error(function () {
//                                    FlashService.show('No se pudo enviar el correo de activación', 'danger', false);
//                                });
//                    },
//                    sendInvitationEmail: function (invitation) {
//                        return $http.post($rootScope.envUrl + '/invitation/', invitation)
//                                .success(function () {
//                                    FlashService.show('Se ha enviado la invitación para activar su cuenta', 'success');
//                                })
//                                .error(function () {
//                                    FlashService.show('No se pudo enviar el correo de activación', 'danger', false);
//                                });
//                    },
//                    resetPassword: function (email) {
//                        FlashService.show('Verificando...', 'info', false);
//                        return $http.post($rootScope.envUrl + '/password/reset/', {
//                            email: email
//                        })
//                                .success(function () {
//                                    FlashService.show('Se le ha enviado un correo con instrucciones para restaurar su contraseña', 'success');
//                                    $location.path('/ingresar');
//                                })
//                                .error(function () {
//                                    FlashService.show('No se pudo enviar el correo de activación', 'danger', false);
//                                });
//                    },
//                    isLogged: function () {
//                        return localStorageService.get('user');
//                    },
//                    isAdmin: function () {
//                        var user = localStorageService.get('user');
//                        if (user) {
//                            return user.is_admin;
//                        }
//                        else {
//                            return false;
//                        }
//                    }
            };

        });

(function () {
    'use strict';

    angular
            .module('rpkspkRpk')
            .controller('VallasController', function ($log) {
                $log.debug('VallasController');
            })
})();

(function () {
  'use strict';

  angular
    .module('rpkspkRpk')
    .controller('QuienesSomosController', function ($log, TablesService) {
      $log.debug('QuienesSomosController');

      var vm = this;
      vm.hitos = [];

      var cont = 0;
      TablesService.listar('hitos').success(function(res){
        angular.forEach(res.resultado, function(value, key){
          if(res.resultado[key].pagina == 1){
            vm.hitos[cont] = res.resultado[key];
            cont++;
          }
        });
        vm.hitosCargados();
      });

      vm.hitosCargados = function(){
        vm.hitos100 = true;
      };

      $log.debug(vm.hitos);

    })
})();

(function () {
    'use strict';

    angular
            .module('rpkspkRpk')
            .controller('PublicidadHdController', function ($log) {
                $log.debug('PublicidadHdController');
            })
})();

(function () {
  'use strict';

  angular
    .module('rpkspkRpk')
    .controller('ProductosController', function ($log, TablesService, $rootScope, $compile, $stateParams, NgMap, $timeout, $window) {
      var vm = this;
      vm.prueba = 10;
      $log.debug('ProductosController');

      //Tarifario
      TablesService.listar('contenidos').success(function(res){
        vm.tarifario = [];
        var cont = 0;
        angular.forEach(res.resultado, function(value, key){
          if(value.paginas_id == 10){
            vm.tarifario.push(value);
            cont++;
          }
        });
        $log.debug('Tarifario');
        $log.debug(vm.tarifario);
      });

      vm.cargarmapa = false;

      //Desplegable ciudades
      vm.ocultarciudadmapa = function () {
        vm.verCiudades = false;
      };
      vm.selciudadmapa = function (c) {
        vm.ciudadSel = c.id;
        vm.nomCiudadSel = c.nombre;
        vm.latcenter = c.latitud;
        vm.loncenter = c.longitud;
        vm.ocultarciudadmapa();
      };

      //Datos para mapa
      TablesService.listar('productosgalerias').success(function (galerias) {
        vm.galeriasprod = galerias.resultado;
        TablesService.listar('ciudades').success(function (ciudades) {
          vm.ciudades = ciudades.resultado;
          vm.ciudadSel = vm.ciudades[0].id;
          vm.nomCiudadSel = vm.ciudades[0].nombre;
          vm.latcenter = vm.ciudades[0].latitud;
          vm.loncenter = vm.ciudades[0].longitud;
          TablesService.listar('categoriasproductos').success(function (categorias) {
            vm.categoriasprod = categorias.resultado;
            //Inicio Switches
            if($stateParams.id){
              vm.swactivos.push(parseInt($stateParams.id));
              $log.debug(vm.swactivos);
            }else{
              angular.forEach(vm.categoriasprod, function (value, k) {
                vm.swactivos.push(value.id);
              });
              $log.debug(vm.swactivos);
            }
            TablesService.mapas().success(function (res) {
              vm.productos = res.resultado;
              angular.forEach(vm.productos, function (prod, k) {
                angular.forEach(vm.galeriasprod, function (value, ngal) {
                  if (value.productos_id == prod.id) {
                    prod.galprod = true;
                  }
                });
              });
              $timeout(function () {
                vm.cargarmapa = true;
              }, 100);
              $timeout(function () {
                var evt = $window.document.createEvent('UIEvents');
                evt.initUIEvent('resize', true, false, $window, 0);
                $window.dispatchEvent(evt);
              }, 500);
              $timeout(function () {
                vm.latcenter = vm.ciudades[0].latitud;
                vm.loncenter = vm.ciudades[0].longitud;
              }, 2000);
              $log.debug('Contenido para mapas');
              $log.debug(vm.productos);
            });
          });
        });
      });

      //Infowindow mapa
      NgMap.getMap({id: 'mapa2'}).then(function (map) {
        vm.map2 = map;
      });
      vm.showCity = function(event, city) {
        $log.debug(city);
        vm.selectedCity = city;
        vm.map2.showInfoWindow('myInfoWindow', this);
      };

      //Buscado icono
      vm.buscarIcon = function(prod){
        angular.forEach(vm.categoriasprod, function (value, k) {
          if (value.id == prod.categoriasproductos_id) {
            vm.iconscategoria = value;
          }
        });
        if(prod.ultimocontrato && prod.categoriasproductos_id != 2 && prod.categoriasproductos_id != 4){
          if($rootScope.diasdif(prod.ultimocontrato.fechafin)>30){
            return vm.iconscategoria.img_ocupado;
          }else{
            if($rootScope.diasdif(prod.ultimocontrato.fechafin)>0){
              return vm.iconscategoria.img_pronto;
            }else{
              return vm.iconscategoria.img_disponible;
            }
          }
        }else{
          return vm.iconscategoria.img_disponible;
        }
      };

      //Ancho de pantalla para elementos
      vm.pantallaW = angular.element(window).width();
      angular.element(window).resize(function () {
        vm.pantallaW = angular.element(window).width();
      });

      vm.swactivos = [];
      //Cambio en switches
      vm.changeSwitches = function (catsel) {
        $log.debug(catsel.id);
        if(vm.swactivos.indexOf(catsel.id)>-1){
          vm.swactivos.splice(vm.swactivos.indexOf(catsel.id), 1);
        }else{
          vm.swactivos.push(catsel.id);
        }
        $log.debug(vm.swactivos);
      };

      //Buscar switch activo
      vm.buscarsw = function(catsel){
        if(vm.swactivos.indexOf(catsel.id)>-1){
          return catsel.icono_active;
        }else{
          return catsel.icono;
        }
      };
      vm.swactive = function(catsel){
        if(vm.swactivos.indexOf(catsel.id)>-1){
          return true;
        }else{
          return false;
        }
      };
      vm.buscategoria = function(id){
        if(vm.swactivos.indexOf(id)>-1){
          return true;
        }else{
          return false;
        }
      };

      //Funciones Galería
      vm.antGal = function (pos) {
        if (pos > 0) {
          vm.fotoactiva = vm.fotoactiva - 1;
        }
      };
      vm.sigGal = function (pos) {
        if (pos < vm.cantidadFotos) {
          vm.fotoactiva = vm.fotoactiva + 1;
        }
      };
      $rootScope.mostrarGaleria = function (idgal) {
        TablesService.listar('productosgalerias').success(function (galeria) {
          vm.galeria = [];
          var cont = 0;
          angular.forEach(galeria.resultado, function (value, key) {
            if (value.productos_id == idgal) {
              vm.galeria[cont] = value;
              vm.galeria[cont]['numimg'] = cont;
              cont++;
            }
          });
          vm.cantidadFotos = cont - 1;
        });
        vm.galeria = true;
      };
      $rootScope.ocultarGaleria = function () {
        $log.debug('Ocultar galeria');
        vm.galeria = false;
      };

      /*vm.ciudades = [];
      vm.seleccionado = 0;
      vm.verCiudades = false;

      TablesService.listar('ciudades').success(function (ciudades) {
        vm.ciudades = ciudades.resultado;
      });

      vm.prodMapa = [];
      vm.swProd = [];

      TablesService.listar('categoriasproductos').success(function (categorias) {
        vm.categorias = categorias.resultado;
        vm.cantProd = vm.categorias.length;
        angular.forEach(vm.categorias, function (value, key) {
          vm.prodMapa[key] = 1;
          if ($stateParams.id) {
            $log.debug('Id encontrado');
            if ($stateParams.id == key) {
              vm.swProd[key + 1] = true;
              vm.categorias[key].icono = vm.categorias[key].icono_active;
            } else {
              vm.swProd[key + 1] = false;
              vm.categorias[key].icono = categorias.resultado[key].icono;
            }
          } else {
            vm.swProd[key + 1] = true;
            vm.categorias[key].icono = vm.categorias[key].icono_active;
          }
        });
      });


      vm.iVMap = ['1'];

      vm.ocultarCiudades = function () {
        vm.verCiudades = false;
      };
      vm.seleccionarCiudad = function (idCiudad) {
        vm.seleccionado = idCiudad - 1;
        vm.iVMap[0] = idCiudad;
        vm.todoMapa(vm.ciudades[idCiudad - 1], vm.prodMapa);
        vm.ocultarCiudades();
      };

      vm.changeProductos = function (idM) {
        $log.debug(vm.categoriasL[idM]);
        vm.cad = vm.categoriasL[idM].nombre + vm.categoriasL[idM].id;
        $log.debug(vm.swProd[idM + 1] + 'Array prod : ' + vm.prodMapa);
        if (vm.swProd[idM + 1] == true) {
          vm.prodMapa[idM] = 1;
          vm.categorias[idM].icono = vm.categorias[idM].icono_active;
        } else {
          vm.prodMapa[idM] = 0;
          vm.categorias[idM].icono = vm.iconos[idM].icono;
        }
        vm.todoMapa(vm.ciudadesL[vm.iVMap[0] - 1], vm.prodMapa);
        $log.debug('C array ' + vm.prodMapa[idM]);
      };

      vm.todoMapa = function (ciudad, prodSw) {

        $log.debug('Lista de ciudades f : ' + vm.ciudades + ciudad);

        /!*angular.forEach(vm.productosL, function(value, key){
         $log.debug('Producto : '+vm.productosL[key].alias);
         });*!/
        $log.debug('Todo ciudades : ' + vm.ciudadesL);
        $log.debug('Todo productos : ' + vm.productosL);
        $log.debug('Todo fechasL : ' + vm.fechasL);
        $log.debug('Todo categoriasL : ' + vm.categoriasL);

        //CREAR MAPA

        var punto = new google.maps.LatLng(ciudad.latitud, ciudad.longitud);
        var myOptions = {
          zoom: 17, center: punto, mapTypeId: google.maps.MapTypeId.TERRAIN, streetViewControl: false
        };
        var map = new google.maps.Map(document.getElementById("mostrarMapa"), myOptions);

        var styles = [
          {
            stylers: [
              {hue: "#0080ff"},
              {saturation: -50},
              {lightness: -3}
            ]
          }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {lightness: -5},
              {visibility: "simplified"}
            ]
          }, {
            featureType: "road",
            elementType: "labels",
            stylers: [
              {visibility: "off"}
            ]
          }
        ];

        map.setOptions({styles: styles});

        $log.debug('Sw - ' + prodSw);

        angular.forEach(vm.productosL, function (value, key) {
          if (vm.productosL[key].ciudades_id == ciudad.id) {
            if (prodSw[(vm.productosL[key].categoriasproductos_id) - 1] == 1) {
              $log.debug(vm.productosL[key].alias);

              vm.fechaDis = 0;
              angular.forEach(vm.fechasL, function (value, k) {
                if (vm.fechasL[k].productos_id == vm.productosL[key].id) {
                  $log.debug(vm.productosL[key].alias + vm.fechasL[k].fechafin);
                  vm.fechaDis = vm.fechasL[k].fechafin;
                }
              });

              if (vm.fechaDis != 0) {
                vm.xDis = vm.fechaDis.split('-');
                vm.nfechaDis = vm.xDis[0] + '-' + vm.xDis[1] + '-' + vm.xDis[2];
                vm.fechaHoy = new Date();
                vm.mes = 0;
                if (vm.fechaHoy.getMonth() + 1 < 9) {
                  vm.mes = '0' + (vm.fechaHoy.getMonth() + 1);
                }
                vm.nfechaHoy = vm.fechaHoy.getFullYear() + '-' + vm.mes + '-' + vm.fechaHoy.getDate();
                $log.debug('Rastreo de ' + vm.nfechaDis + ' a ' + vm.nfechaHoy);

                var aFecha1 = vm.nfechaDis.split('-');
                var aFecha2 = vm.nfechaHoy.split('-');
                var fFecha1 = new Date(aFecha1[0] + ',' + aFecha1[1] + ',' + aFecha1[2]);
                var fFecha2 = new Date(aFecha2[0] + ',' + aFecha2[1] + ',' + aFecha2[2]);
                var dif = fFecha1.getTime() - fFecha2.getTime();
                var dias = Math.round(dif / (1000 * 60 * 60 * 24));

                $log.debug(vm.productosL[key].alias + '\n Dias dif : ' + dias);

                if (dias > 30) {
                  vm.iconMarker = vm.categoriasL[vm.productosL[key].categoriasproductos_id - 1].img_ocupado;
                  vm.estadoProd = 'prodOcupado';
                  vm.txEstado = 'Ocupado';
                } else {
                  vm.iconMarker = vm.categoriasL[vm.productosL[key].categoriasproductos_id - 1].img_pronto;
                  vm.estadoProd = 'prodPronto';
                  vm.txEstado = 'Pronto a liberarse';
                }

              } else {
                vm.iconMarker = vm.categoriasL[vm.productosL[key].categoriasproductos_id - 1].img_disponible;
                vm.estadoProd = 'prodDisponible';
                vm.txEstado = 'Disponible';
              }

              if (vm.categoriasL[vm.productosL[key].categoriasproductos_id - 1].id == 2 || vm.categoriasL[vm.productosL[key].categoriasproductos_id - 1].id == 4) {
                $log.debug('Pantalla o Pantalla led');
                vm.iconMarker = vm.categoriasL[vm.productosL[key].categoriasproductos_id - 1].img_disponible;
                vm.estadoProd = 'prodDisponible';
                vm.txEstado = 'Disponible';
              }

              var lat = vm.productosL[key].latitud;
              var lon = vm.productosL[key].longitud;
              var tituloMap = vm.productosL[key].alias;
              var puntoMap = new google.maps.LatLng(lat, lon);
              var iconBase = '';
              var markerMap = new google.maps.Marker({
                position: puntoMap,
                title: tituloMap,
                //icon: iconBase + vm.iconMarkerMap
                icon: iconBase + vm.iconMarker
              });
              markerMap.setMap(map);

              var galExist = 0;
              angular.forEach(vm.galeriasL, function (value, ngal) {
                if (vm.galeriasL[ngal].productos_id == vm.productosL[key].id) {
                  galExist = 1;
                }
              });
              var contentString;
              if (galExist != 0) {
                $log.debug(vm.productosL[key].alias + ' Galeria existente');
                contentString = '<div class="info-marker">' +
                  '<div class="info"><div class="desc-mk">' +
                  '<h3>' + vm.productosL[key].alias + '</h3>' +
                  '<p><span>Dirección: </span>' + vm.productosL[key].direccion + '</p>' +
                  '<p class=' + vm.estadoProd + '>' + vm.txEstado + '</p>' +
                  '</div>' +
                  '<div class="img-mk">' +
                  '<img src="' + vm.productosL[key].imagen + '">' +
                  '</div></div>' +
                  '<p data-ng-if="'+vm.productosL[key].activo+'==0">Este producto está en mantenimiento</p>' +
                  '<div class="botones">' +
                  '<a class="bt-transparente" data-ng-click="mostrarGaleria(' + vm.productosL[key].id + ');" data-ng-model="botonprueba">VER GALERÍA</a>' +
                  '<a href="#/informacion/' + vm.productosL[key].id + '" class="bt-transparente">SOLICITAR INFORMACIÓN</a>' +
                  '</div>' +
                  '</div>';
              } else {
                $log.debug(vm.productosL[key].alias + ' Sin galeria');
                contentString = '<div class="info-marker">' +
                  '<div class="info"><div class="desc-mk">' +
                  '<h3>' + vm.productosL[key].alias + '</h3>' +
                  '<p><span>Dirección: </span>' + vm.productosL[key].direccion + '</p>' +
                  '<p class=' + vm.estadoProd + '>' + vm.txEstado + '</p>' +
                  '</div>' +
                  '<div class="img-mk">' +
                  '<img src="' + vm.productosL[key].imagen + '">' +
                  '</div></div>' +
                  '<p data-ng-if="'+vm.productosL[key].activo+'==0">Este producto está en mantenimiento</p>' +
                  '<div class="botones">' +
                  '<a href="#/informacion/' + vm.productosL[key].id + '" class="bt-transparente">SOLICITAR INFORMACIÓN</a>' +
                  '</div>' +
                  '</div>';
              }

              $log.debug('Creando emergente');

              var compiled = $compile(contentString)($rootScope);
              var infowindow = new google.maps.InfoWindow({
                content: compiled[0],
                maxWidth: 400
              });
              markerMap.addListener('click', function () {
                infowindow.open(map, markerMap);
              });

            } else {
              $log.debug('Sw sin vallas');
            }
          } else {
            $log.debug('Ciudad sin vallas');
          }
        });

      };

      vm.mostrarDatos = function (envC, swProd) {
        $log.debug('Lista ciudades : ' + vm.ciudadesL);
        $log.debug('Lista productos : ' + vm.productosL);
        $log.debug('Lista fechasL : ' + vm.fechasL);
        $log.debug('Lista categoriasL : ' + vm.categoriasL);
        vm.todoMapa(envC, swProd);
      };

      TablesService.listar('ciudades').success(function (ciudades) {
        vm.ciudadesL = ciudades.resultado;

        TablesService.listar('productosgalerias').success(function (galerias) {

          vm.galeriasL = galerias.resultado;

          TablesService.listar('productos').success(function (res) {

            vm.productosL = res.resultado;

            TablesService.listar('categoriasproductos').success(function (categorias) {

              vm.categoriasL = categorias.resultado;
              vm.iconos = vm.categoriasL;
              angular.forEach(vm.categoriasL, function (value, key) {
                if ($stateParams.id) {
                  $log.debug('Id encontrado');
                  if ($stateParams.id == key) {
                    vm.prodMapa[key] = true;
                  } else {
                    vm.prodMapa[key] = false;
                  }
                } else {
                  vm.prodMapa[key] = true;
                }
              });

              TablesService.listar('usuariosproductos').success(function (disponible) {

                vm.fechasL = disponible.resultado;

                vm.mostrarDatos(vm.ciudadesL[vm.iVMap[0] - 1], vm.prodMapa);

                $log.debug('inicio ciudad : ' + vm.iVMap[0] + vm.ciudadesL[vm.iVMap[0] - 1] + ' array ' + vm.prodMapa);

              });

            });

          });

        });

      });

      vm.antGal = function (pos) {
        if (pos > 0) {
          vm.fotoactiva = vm.fotoactiva - 1;
        }
      };
      vm.sigGal = function (pos) {
        if (pos < vm.cantidadFotos) {
          vm.fotoactiva = vm.fotoactiva + 1;
        }
      };
      $rootScope.mostrarGaleria = function (idgal) {
        $log.debug('Example of infowindow with ng-click');
        TablesService.listar('productosgalerias').success(function (galeria) {

          vm.galeria = [];
          var cont = 0;
          angular.forEach(galeria.resultado, function (value, key) {
            if (galeria.resultado[key].productos_id == idgal) {
              vm.galeria[cont] = galeria.resultado[key];
              vm.galeria[cont]['numimg'] = cont;
              cont++;
            }
          });
          vm.cantidadFotos = cont - 1;
        });
        vm.galeria = true;

      };
      $rootScope.ocultarGaleria = function () {
        $log.debug('Ocultar galeria');
        vm.galeria = false;
      };
      angular.element('.info-marker').parent().parent().parent().addClass("cont-infoM");
      angular.element(window).resize(function () {
        vm.mostrarDatos(vm.ciudadesL[vm.iVMap[0] - 1], vm.prodMapa);
      });*/

    })
})();

(function () {
    'use strict';

    angular
            .module('rpkspkRpk')
            .controller('PasarelasController', function ($log) {
                $log.debug('PasarelasController');
            })
})();

(function () {
    'use strict';

    angular
            .module('rpkspkRpk')
            .controller('MapaProductosController', function ($log) {
                $log.debug('MapaProductosController');
            })
})();

(function () {
  'use strict';

  angular
    .module('rpkspkRpk')
    .controller('LoginController', function ($log) {
      $log.debug('LoginController');
    })
})();

(function () {
  'use strict';

  angular
    .module('rpkspkRpk')
    .controller('InicioController', function ($log, AuthService, UsersService, snSkrollr, TablesService, PreloaderImage, $timeout, $rootScope) {
      $log.debug(location.hash);
      snSkrollr.init({
        /*render: function (data) {
          $log.debug(data.curTop);
        }*/
      });
      var vm = this;
      vm.prueba = 10;

      if($rootScope.dispositivo == 'iPad' || angular.element(window).width()<=992){
        snSkrollr.destroy();
      }
      angular.element(window).resize(function () {
        if($rootScope.dispositivo == 'iPad' || angular.element(window).width()<=992){
          snSkrollr.destroy();
        }
      });

      /*vm.progressbar = ngProgressFactory.createInstance();
      vm.progressbar.start();*/

      angular.element(document).load(function() {
        $log.debug('Página cargada');
      });


      var pathLocations = 'app/img/';
      var imageLocations = [
        pathLocations + 'rpk1/4_ciudad_n3.jpg',
        pathLocations + 'rpk1/4_ciudad_n2.jpg',
        pathLocations + 'rpk1/4_ciudad.jpg',
        pathLocations + 'rpk1/2_cables.png',
        pathLocations + 'rpk1/1_semaforo.png',
        pathLocations + 'rpk2/2_fondo_n1.jpg',
        pathLocations + 'rpk2/2_fondo_n2.jpg',
        pathLocations + 'rpk2/1_persona.png',
        pathLocations + 'rpk3/6_fondo.jpg',
        pathLocations + 'rpk3/5_ciudad.png',
        pathLocations + 'rpk3/5_ciudad_2.png',
        pathLocations + 'rpk3/4_arbusto.png',
        pathLocations + 'rpk3/3_balcon.png',
        pathLocations + 'rpk3/2_hojas.png',
        pathLocations + 'rpk3/1_poste.png',
        pathLocations + 'rpk4/1_baranda.png',
        pathLocations + 'rpk4/2_ciudad1.png',
        pathLocations + 'rpk4/2_ciudad2.png',
        pathLocations + 'rpk4/3_edificios.png',
        pathLocations + 'rpk4/4_fondo.jpg'
      ];
      vm.percentLoaded = 0;
      vm.loader_home = function () {
        $log.debug('Iniciando carga');
        PreloaderImage.preloadImages(imageLocations)
          .then(function handleResolve() {
            $timeout(function(){
              //angular.element('#percent_loading').css({opacity:'0'});
              $timeout(function(){
                //angular.element('#button_next').css({display:'block'});
                angular.element('.loader').fadeOut(200);
              },500);
            },500);
            $log.info('Preload Successful');
          },
          function handleReject() {
            $log.info('Preload Failure');
          },
          function handleNotify(event) {
            vm.percentLoaded = event.percent;
            //angular.element('#mask_loader').css({width:(100-event.percent)+'%'});
          }
        );
      };

      $log.debug('InicioController');

      TablesService.listar('contenidos').success(function(res){
        vm.contenido = [];
        var cont = 0;
        angular.forEach(res.resultado, function(value, key){
          if(res.resultado[key].paginas_id == 2){
            vm.contenido[cont] = res.resultado[key].contenido;
            cont++;
          }
        });
        $log.debug('Contenido');
        $log.debug(vm.contenido);
      });

      TablesService.listar('ciudades').success(function(ciudades){
        vm.ciudades = ciudades.resultado;
        TablesService.listar('oficinas').success(function(oficinas){
          vm.oficinas = oficinas.resultado;
        });
      });

      /*function login() {
        AuthService.login('admin@rpk.com', 'admin');
      }
      TablesService.listar('usuarios').success(function(res){
        $log.debug(res);
      });
      if (login()) {
        UsersService.all()
          .success(function (users) {
            vm.registros = users;
          })
          .error(function (error) {
            vm.error = error;
          });
      }*/
      if(angular.element(window).width()>992 && $rootScope.dispositivo != 'iPad'){
        vm.loader_home();
      }
      angular.element(window).resize(function(){
        if(angular.element(window).width()>992 && $rootScope.dispositivo != 'iPad'){
          vm.loader_home();
        }
      });
    })
})();

(function () {
  'use strict';

  angular
    .module('rpkspkRpk')
    .controller('InformacionController', function ($log, TablesService, SinApiService, $stateParams, vcRecaptchaService) {
      var vm = this;
      angular.element(document).ready(function () {
        jQuery.ajax({
          url: 'https://www.google.com/recaptcha/api.js?hl=es',
          dataType: 'script',
          async: true,
          deferer: true
        });
      });

      //Captcha
      vm.response = null;
      vm.widgetId = null;
      vm.model = {
        key: '6LfyRRgUAAAAAFRimRoi7mSkRIcvl7eX8KxYIN0P'
      };
      vm.setResponse = function (response) {
        console.info('Response available');
        vm.response = response;
        if(response){
          vm.enableSubmit = true;
        }
      };
      vm.setWidgetId = function (widgetId) {
        console.info('Created widget ID: %s', widgetId);
        vm.widgetId = widgetId;
      };
      vm.cbExpiration = function() {
        console.info('Captcha expired. Resetting response object');
        vcRecaptchaService.reload(vm.widgetId);
        vm.response = null;
      };

      vm.generarSeguridad = function () {
        vm.nombre = '';
        vm.email = '';
        vm.telefono = '';
        vm.mensaje = '';
        vm.gc = '';
        grecaptcha.reset();
      };
      TablesService.visualizar('productos', $stateParams.id)
        .success(function (producto) {
          vm.producto = producto.resultado[0];
          vm.nombre = '';
          vm.email = '';
          vm.telefono = '';
          vm.mensaje = '';
          vm.mensajeform = 'Por favor complete el formulario';
          vm.mensajeEnviado = false;
          vm.enviarSolicitud = function () {
            if (vm.nombre) {
              if (vm.email) {
                if (vm.telefono) {
                  if (vm.mensaje) {
                    var data = {
                      nombre: vm.nombre,
                      email: vm.email,
                      telefono: vm.telefono,
                      producto: vm.producto.alias + ': ' + vm.producto.direccion,
                      mensaje: vm.mensaje,
                      gc: jQuery('#g-recaptcha-response').val()
                    };
                    SinApiService.enviarMailSolicitud(data)
                      .then(function (res) {
                        if (res.data.respuesta) {
                          $log.debug(res.data.resultado);
                          vm.mensajeform = 'Solicitud enviada satisfactoriamente';
                          vm.mensajeEnviado = true;
                          vm.generarSeguridad();
                        } else {
                          vm.mensajeform = 'No se pudo enviar la solicitud';
                          vm.mensajeEnviado = false;
                          vm.generarSeguridad();
                        }
                      })
                      .catch(function (response) {
                        switch (response.data.error) {
                          case 'is_robot':
                            $log.debug('Intento de conexión forzado.');
                            vm.mensajeform = 'Intento de conexión forzado.';
                            vm.generarSeguridad();
                            break;
                          case 'not_security_validation':
                            $log.debug('Verifique que no es un robot.');
                            vm.mensajeform = 'Verifique que no es un robot.';
                            vm.generarSeguridad();
                            break;
                        }
                      });
                  } else {
                    vm.mensajeform = 'Introduzca su mensaje';
                  }
                } else {
                  vm.mensajeform = 'Introduzca un número de teléfono';
                }
              } else {
                vm.mensajeform = 'Introduzca una dirección de correo';
              }
            } else {
              vm.mensajeform = 'Introduzca su nombre completo';
            }
          };
        });
    });
})();

(function () {
  'use strict';

  angular
    .module('rpkspkRpk')
    .controller('HeaderController', function ($log, TablesService) {
      var vm = this;
      $log.debug('HeaderController');
      vm.mproductos = [];
      TablesService.listar('categoriasproductos').success(function (categorias) {
        vm.mproductos = categorias.resultado;
        $log.debug(vm.mproductos);
        vm.vmenu = true;
      });
    })
})();

(function () {
  'use strict';

  angular
    .module('rpkspkRpk')
    .controller('ContactoController', function (TablesService, SinApiService, $log, NgMap, vcRecaptchaService) {
      var vm = this;
      angular.element(document).ready(function () {
        jQuery.ajax({
          url: 'https://www.google.com/recaptcha/api.js?hl=es',
          dataType: 'script',
          async: true,
          deferer: true
        });
      });
      /*vm.ofslide = 1;
      angular.forEach(vm.oficinas, function (value, k) {
        if(value.id = $stateParams.id){
          vm.contratos = value;
        }
      });*/

      //Captcha
      vm.response = null;
      vm.widgetId = null;
      vm.model = {
        key: '6LfyRRgUAAAAAFRimRoi7mSkRIcvl7eX8KxYIN0P'
      };
      vm.setResponse = function (response) {
        console.info('Response available');
        vm.response = response;
        if(response){
          vm.enableSubmit = true;
        }
      };
      vm.setWidgetId = function (widgetId) {
        console.info('Created widget ID: %s', widgetId);
        vm.widgetId = widgetId;
      };
      vm.cbExpiration = function() {
        console.info('Captcha expired. Resetting response object');
        vcRecaptchaService.reload(vm.widgetId);
        vm.response = null;
      };

      TablesService.listar('oficinas').success(function (oficinas) {
        vm.oficinas = oficinas.resultado;
        $log.debug('Oficinas');
        $log.debug(vm.oficinas);
      });
      NgMap.getMap({id: 'mapacon'}).then(function (map) {
        vm.map = map;
        $log.debug(vm.map);
      });

      vm.generarSeguridad = function () {
        vm.nombre = '';
        vm.email = '';
        vm.telefono = '';
        vm.empresa = '';
        vm.mensaje = '';
        vm.gc = '';
        grecaptcha.reset();
      };

      TablesService.listar('contenidos')
        .success(function (res) {
          vm.contenido = new Array();
          var cont = 0;
          angular.forEach(res.resultado, function (value, key) {
            if (res.resultado[key].paginas_id == 3) {
              vm.contenido[cont] = res.resultado[key].contenido;
              cont++;
            }
          });
          vm.nombre = '';
          vm.email = '';
          vm.telefono = '';
          vm.empresa = '';
          vm.mensaje = '';
          vm.mensajeform = vm.contenido[0];
          vm.enviarContacto = function () {
            if (vm.nombre) {
              if (vm.email) {
                if (vm.telefono) {
                  if (vm.mensaje) {
                    var data = {
                      nombre: vm.nombre,
                      email: vm.email,
                      telefono: vm.telefono,
                      empresa: vm.empresa,
                      mensaje: vm.mensaje,
                      gc: jQuery('#g-recaptcha-response').val()
                    };
                    SinApiService.enviarMailContacto(data)
                      .then(function (res) {
                        if (res.data.respuesta) {
                          $log.debug(res.data.resultado);
                          vm.mensajeform = 'Mensaje enviado satisfactoriamente';
                          vm.generarSeguridad();
                        } else {
                          vm.mensajeform = 'No se pudo enviar el mensaje';
                          vm.generarSeguridad();
                        }
                      })
                      .catch(function (response) {
                        switch (response.data.error) {
                          case 'is_robot':
                            $log.debug('Intento de conexión forzado.');
                            vm.mensajeform = 'Intento de conexión forzado.';
                            vm.generarSeguridad();
                            break;
                          case 'not_security_validation':
                            $log.debug('Verifique que no es un robot.');
                            vm.mensajeform = 'Verifique que no es un robot.';
                            vm.generarSeguridad();
                            break;
                        }
                      });
                  } else {
                    vm.mensajeform = 'Introduzca su mensaje';
                  }
                } else {
                  vm.mensajeform = 'Introduzca un número de teléfono';
                }
              } else {
                vm.mensajeform = 'Introduzca una dirección de correo';
              }
            } else {
              vm.mensajeform = 'Introduzca su nombre completo';
            }
          };
        });
    });
})();

(function () {
  'use strict';

  angular
    .module('rpkspkRpk')
    .controller('BuscadorController', function ($log, TablesService) {
      var vm = this;
      $log.debug('BuscadorController');

      /*vm.enviarBusqueda = function () {
        var parametros = {criterio: vm.buscar};
        TablesService.buscar(parametros).success(function (resultados) {
          vm.resultados = resultados.resultado;
          $log.debug(vm.resultados);
        });
      };*/

      vm.verAC = function(){
        if(vm.buscar.length>2){
          vm.mAC = true;
          var parametros = {criterio: vm.buscar};
          TablesService.buscar(parametros).success(function (resultados) {
            vm.resultados = resultados.resultado;
            $log.debug(vm.resultados);
          });
        }else{
          vm.mAC = false;
        }
      };

      /*var parametros = {
        criterio: 'pasarela'
      };
      TablesService.buscar(parametros).success(function (resultados) {
        vm.resultados = resultados.resultado;
        $log.debug(vm.resultados);
      });*/

    })
    .filter('highlight', function($sce) {
      return function(text, phrase) {
        if (phrase) text = text.replace(new RegExp('('+phrase+')', 'gi'), '<span class="resaltado">$1</span>')
        return $sce.trustAsHtml(text)
      }
    })
    .directive('autcomplete', function () {
      return{
        restrict: 'C',
        link: function (scope, element, attrs) {
          var posAutoc = function(){
            var left = element.parent('.search').prop('offsetLeft');
            var top = element.parent('.search').prop('offsetTop');
            var sH = element.parent('.search').prop('offsetHeight');
            var contH = $(window).height()-top-sH-15;
            element.css('top', top+sH+'px');
            element.css('left', left+'px');
            element.css('max-height', contH+'px');
          };
          posAutoc();
          $(window).resize(function(){
            posAutoc();
          });
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('rpkspkRpk')
    .directive('inputAnimate', function () {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          scope.$watch(attrs.ngModel, function (contInput) {
            if(contInput){
              element.addClass('input-lleno');
            }else{
              element.removeClass('input-lleno');
            }
          });
        }
      };
    })
})();

(function () {
  'use strict';

  angular
    .module('rpkspkRpk')
    .directive('hito', function ($log) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var texto = element.find('.c-hitotx cont-tx');
          var imagen = element.find('.c-hitoimg img');
          $log.debug(texto);
          if(texto.height()>imagen.height()){
            $log.debug('texto : '+texto.height());
            imagen.height(texto.height());
          }else{
            texto.height(imagen.height());
            $log.debug('imágen : '+imagen.height());
          }
        }
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('rpkspkRpk')
    .directive('mapaHeight', function ($log) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          $log.debug('Aplicando directiva mapa');
          var changemh = function () {
            var wH = 0;
            if(angular.element(window).width()>992){
              wH = angular.element(window).height() - 215;
            }else{
              wH = angular.element(window).height() - 140;
            }
            element.css('height', wH + 'px');
          };
          changemh();
          angular.element(window).resize(function () {
            changemh();
          });
        }
      }
    });
})();

(function() {
  'use strict';

  angular
      .module('rpkspkRpk')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('rpkspkRpk')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('rpkspkRpk')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('rpkspkRpk')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

/*! skrollr-menu 1.0.3 (2015-06-19) | Alexander Prinzhorn - https://github.com/Prinzhorn/skrollr-menu | Free to use under terms of MIT license */
(function(t,e){"use strict";var n=500,a="sqrt",o=1,r="data-menu-top",i="data-menu-offset",u="data-menu-duration",c="data-menu-ignore",l=e.skrollr,s=e.history,f=!!s.pushState,h=function(e){return e!==t&&e?"A"===e.tagName.toUpperCase()?e:h(e.parentNode):!1},p=function(t){if(1===t.which||0===t.button){var e=h(t.target);e&&m(e)&&t.preventDefault()}},m=function(n,a){var o;if(y){if(n.hostname!==e.location.hostname)return!1;if(n.pathname!==t.location.pathname)return!1;o=n.hash}else o=n.getAttribute("href");if(!/^#/.test(o))return!1;if(!a&&null!==n.getAttribute(c))return!1;var l,h;if(h=T?T(n):n.getAttribute(r),null!==h)l=/p$/.test(h)?h.slice(0,-1)/100*t.documentElement.clientHeight:+h*k;else{var p=t.getElementById(o.substr(1));if(!p)return!1;l=v.relativeToAbsolute(p,"top","top");var m=p.getAttribute(i);null!==m&&(l+=+m)}f&&N&&!a&&s.pushState({top:l},"",o);var d=parseInt(n.getAttribute(u),10),q=A(v.getScrollTop(),l);return isNaN(d)||(q=d),E&&E(o,l),S&&!a?v.animateTo(l,{duration:q,easing:b}):g(function(){v.setScrollTop(l)}),!0},d=function(){if(e.location.hash&&t.querySelector){var n=t.querySelector('a[href="'+e.location.hash+'"]');n||(n=t.createElement("a"),n.href=e.location.hash),m(n,!0)}},g=function(t){e.setTimeout(t,1)};l.menu={},l.menu.init=function(r,i){v=r,i=i||{},b=i.easing||a,S=i.animate!==!1,A=i.duration||n,T=i.handleLink,k=i.scale||o,y=i.complexLinks===!0,E=i.change,N=i.updateUrl!==!1,"number"==typeof A&&(A=function(t){return function(){return t}}(A)),l.addEvent(t,"click",p),f&&l.addEvent(e,"popstate",function(t){var e=t.state||{},n=e.top||0;g(function(){v.setScrollTop(n)})},!1),d()},l.menu.click=function(t){m(t)};var v,b,A,S,T,k,y,E,N;g(function(){e.location.hash&&e.scrollTo(0,0)})})(document,window);
(function () {
  'use strict';
  angular
    .module('rpkspkRpk')
    .run(function ($log, $rootScope, snSkrollr, TablesService) {
      //$rootScope.api = 'http://rpkspkapi.indomita.bo';
      //$rootScope.api = 'http://localhost:8000';
      $rootScope.api = 'http://api.rpk.com.bo';
      $rootScope.verdisp = function () {
        $rootScope.agente = navigator.userAgent;
        $rootScope.version = navigator.appVersion;
        $rootScope.dispositivo = ($rootScope.agente.match(/Iphone/i) || $rootScope.agente.match(/Ipod/i) || $rootScope.agente.match(/Android/i) || $rootScope.agente.match(/J2ME/i) || $rootScope.agente.match(/BlackBerry/i) || $rootScope.agente.match(/iPhone|iPad|iPod/i) || $rootScope.agente.match(/Opera Mini/i) || $rootScope.agente.match(/IEMobile/i) || $rootScope.agente.match(/Mobile/i) || $rootScope.agente.match(/Windows Phone/i) || $rootScope.agente.match(/windows mobile/i) || $rootScope.agente.match(/windows ce/i) || $rootScope.agente.match(/webOS/i) || $rootScope.agente.match(/palm/i) || $rootScope.agente.match(/bada/i) || $rootScope.agente.match(/series60/i) || $rootScope.agente.match(/nokia/i) || $rootScope.agente.match(/symbian/i) || $rootScope.agente.match(/HTC/i));
        $rootScope.dispositivo = $rootScope.dispositivo == null ? 'Monitor' : $rootScope.dispositivo;
        if (($rootScope.dispositivo == 'iPhone') || ($rootScope.dispositivo == 'iPad') || ($rootScope.dispositivo == 'iPod')) {
          var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
          $rootScope.iosVersion = parseInt(v[1], 10);
          if ($rootScope.iosVersion < 6) {
            angular.element('body').find('.flex').addClass('wbkitbox');
          }
        } else {
          $rootScope.iosVersion = 0;
        }
        $rootScope.responsivo = $rootScope.dispositivo == 'Monitor' ? false : true;
        $rootScope.orientacion = ((angular.element(window).width() > angular.element(window).height()) ? 'l' : 'p');
        $rootScope.celp_p = angular.element(window).width() <= 320 && angular.element(window).height() <= 480;
        $rootScope.celp_l = angular.element(window).width() <= 480 && angular.element(window).height() <= 320 && (!$rootScope.celp_p);
        $rootScope.celg_p = angular.element(window).width() < 600 && angular.element(window).height() < 800 && (!$rootScope.celp_l && !$rootScope.celp_p);
        $rootScope.celg_l = angular.element(window).width() < 800 && angular.element(window).height() < 600 && (!$rootScope.celg_p && !$rootScope.celp_l && !$rootScope.celp_p);
        $rootScope.tabp_p = angular.element(window).width() < 768 && angular.element(window).height() < 1024 && (!$rootScope.celg_l && !$rootScope.celg_p && !$rootScope.celp_l && !$rootScope.celp_p);
        $rootScope.tabp_l = angular.element(window).width() < 1024 && angular.element(window).height() < 768 && (!$rootScope.tabp_p && !$rootScope.celg_l && !$rootScope.celg_p && !$rootScope.celp_l && !$rootScope.celp_p);
        $rootScope.tabg_p = angular.element(window).width() < 960 && angular.element(window).height() < 1200 && (!$rootScope.tabp_l && !$rootScope.tabp_p && !$rootScope.celg_l && !$rootScope.celg_p && !$rootScope.celp_l && !$rootScope.celp_p);
        $rootScope.tabg_l = angular.element(window).width() < 1200 && angular.element(window).height() < 960 && ($rootScope.responsivo && !$rootScope.tabg_p && !$rootScope.tabp_l && !$rootScope.tabp_p && !$rootScope.celg_l && !$rootScope.celg_p && !$rootScope.celp_l && !$rootScope.celp_p);
        $rootScope.desp = angular.element(window).width() < 1200 && angular.element(window).height() < 960 && (!$rootScope.tabg_l && !$rootScope.tabg_p && !$rootScope.tabp_l && !$rootScope.tabp_p && !$rootScope.celg_l && !$rootScope.celg_p && !$rootScope.celp_l && !$rootScope.celp_p);
        $rootScope.desg = angular.element(window).width() >= 1200 && (!$rootScope.desp && !$rootScope.tabg_l && !$rootScope.tabg_p && !$rootScope.tabp_l && !$rootScope.tabp_p && !$rootScope.celg_l && !$rootScope.celg_p && !$rootScope.celp_l && !$rootScope.celp_p);
        $rootScope.escel = ($rootScope.celp_p || $rootScope.celp_l || $rootScope.celg_p || $rootScope.celg_l);
        $rootScope.establet = ($rootScope.tabp_p || $rootScope.tabp_l || $rootScope.tabg_p || $rootScope.tabg_l);
        $rootScope.esdesk = !$rootScope.responsivo && ($rootScope.desp || $rootScope.desg);
        $log.debug('|==================================|');
        $log.debug('|           DISPOSITIVO:           |');
        $log.debug('|----------------------------------|');
        $log.debug('| Ancho: ' + angular.element(window).width() + 'px');
        $log.debug('| Alto: ' + angular.element(window).height() + 'px');
        $log.debug('| Dispositivo: ' + $rootScope.dispositivo);
        $log.debug('| Version de IOS: ' + $rootScope.iosVersion);
        $log.debug('| Responsivo: ' + ($rootScope.responsivo ? 'SI' : 'NO'));
        $log.debug('| Orientacion: ' + ($rootScope.orientacion == 'p' ? 'VERTICAL' : 'HORIZONTAL'));
        $log.debug('| Celular: ' + ($rootScope.escel ? 'SI' : 'NO'));
        $log.debug('| Tableta: ' + ($rootScope.establet ? 'SI' : 'NO'));
        $log.debug('| Escritorio: ' + ($rootScope.esdesk ? 'SI' : 'NO'));
        $log.debug('|----------------------------------|');
        $log.debug('| Celular pequenho vertical: ' + ($rootScope.celp_p ? 'SI' : 'NO'));
        $log.debug('| Celular pequenho horizontal: ' + ($rootScope.celp_l ? 'SI' : 'NO'));
        $log.debug('| Celular grande vertical: ' + ($rootScope.celg_p ? 'SI' : 'NO'));
        $log.debug('| Celular grande horizontal: ' + ($rootScope.celg_l ? 'SI' : 'NO'));
        $log.debug('| Tableta pequenha vertical: ' + ($rootScope.tabp_p ? 'SI' : 'NO'));
        $log.debug('| Tableta pequenha horizontal: ' + ($rootScope.tabp_l ? 'SI' : 'NO'));
        $log.debug('| Tableta grande vertical: ' + ($rootScope.tabg_p ? 'SI' : 'NO'));
        $log.debug('| Tableta grande horizontal: ' + ($rootScope.tabg_l ? 'SI' : 'NO'));
        $log.debug('| Monitor pequenho: ' + ($rootScope.desp ? 'SI' : 'NO'));
        $log.debug('| Monitor grande: ' + ($rootScope.desg ? 'SI' : 'NO'));
        $log.debug('|==================================|');
        if(angular.element(window).width()<=992){
          snSkrollr.destroy();
        }
      };
      $rootScope.verdisp();
      angular.element(window).resize(function () {
        $rootScope.verdisp();
      }).resize();
      angular.element(window).bind('resize', function () {
        $rootScope.$apply();
      });
      angular.element(window).bind('hashchange', function () {
        if (location.hash != '#/') {
          snSkrollr.destroy();
          $log.debug('Skrollr destruído');
        }
      });

      $rootScope.diasdif = function (fecha) {
        if(fecha){
          var sinHora = fecha.split(" ");
          var fechaHoy = new Date();
          var ff = sinHora[0].split("-");
          var fechaFin = new Date(ff[0] + ',' + ff[1] + ',' + ff[2]);
          var dif = fechaFin.getTime() - fechaHoy.getTime();
          var dias = Math.round(dif / (1000 * 60 * 60 * 24));
          return dias;
        }
      };

      TablesService.listar('oficinas').success(function(oficinas){
        $rootScope.footeroficinas = oficinas.resultado[0];
      });

    });
})();

(function () {
  'use strict';

  angular
    .module('rpkspkRpk')
    .config(function ($stateProvider, $urlRouterProvider, $authProvider) {
      $stateProvider
        .state('/inicio', {
          url: '/',
          templateUrl: 'app/views/inicio/inicio.html',
          controller: 'InicioController',
          controllerAs: 'inicio',
          ncyBreadcrumb: {
            label: 'INICIO'
          }
        })
        .state('/productos', {
          url: '/productos',
          templateUrl: 'app/views/productos/productos.html',
          controller: 'ProductosController',
          controllerAs: 'productos',
          ncyBreadcrumb: {
            label: 'MAPA DE PRODUCTOS',
            parent: '/inicio'
          }
        })
        .state('/productossel', {
          url: '/productos/:id',
          templateUrl: 'app/views/productos/productos.html',
          controller: 'ProductosController',
          controllerAs: 'productos',
          ncyBreadcrumb: {
            label: 'MAPA DE PRODUCTOS',
            parent: '/inicio'
          }
        })
        .state('/informacion', {
          url: '/informacion/',
          templateUrl: 'app/views/productos/informacion.html',
          ncyBreadcrumb: {
            label: 'SOLICITAR INFORMACIÓN',
            parent: '/productos'
          }
        })
        .state('/informacionsel', {
          url: '/informacion/:id',
          templateUrl: 'app/views/productos/informacion.html',
          controller: 'InformacionController',
          controllerAs: 'info',
          ncyBreadcrumb: {
            label: 'SOLICITAR INFORMACIÓN',
            parent: '/productos'
          }
        })
        .state('/vallas', {
          url: '/vallas',
          templateUrl: 'app/views/vallas/vallas.html',
          controller: 'VallasController',
          controllerAs: 'vallas'
        })
        .state('/publicidadhd', {
          url: '/publicidadhd',
          templateUrl: 'app/views/publicidadhd/publicidadhd.html',
          controller: 'PublicidadHdController',
          controllerAs: 'publicidadhd'
        })
        .state('/pasarelas', {
          url: '/pasarelas',
          templateUrl: 'app/views/pasarelas/pasarelas.html',
          controller: 'PasarelasController',
          controllerAs: 'pasarelas'
        })
        .state('/mapaproductos', {
          url: '/mapaproductos',
          templateUrl: 'app/views/mapaproductos/mapaproductos.html',
          controller: 'MapaProductosController',
          controllerAs: 'mapaproductos'
        })
        .state('/quienessomos', {
          url: '/quienessomos',
          templateUrl: 'app/views/quienessomos/quienessomos.html',
          controller: 'QuienesSomosController',
          controllerAs: 'quienes',
          ncyBreadcrumb: {
            label: 'QUIENES SOMOS',
            parent: '/inicio'
          }
        })
        .state('/contacto', {
          url: '/contacto',
          templateUrl: 'app/views/contacto/contacto.html',
          controller: 'ContactoController',
          controllerAs: 'contacto',
          ncyBreadcrumb: {
            label: 'CONTACTO',
            parent: '/inicio'
          }
        })
        .state('/login', {
          url: '/login',
          templateUrl: 'app/views/login/login.html',
          controller: 'LoginController',
          controllerAs: 'login',
          ncyBreadcrumb: {
            label: 'LOGIN',
            parent: '/inicio'
          }
        })
        .state('/search', {
          url: '/search',
          templateUrl: 'app/views/search.html',
          controller: 'BuscadorController',
          controllerAs: 'bsq',
          ncyBreadcrumb: {
            label: 'BUSCAR',
            parent: '/inicio'
          }
        });
      $urlRouterProvider.otherwise('/');
//      $authProvider.loginUrl = 'http://localhost:8000/api/authenticate';
      $authProvider.loginUrl = 'http://rpkspkapi.indomita.bo/api/authenticate';

      //$log.debug($location.hash());
    })
})();

/* global malarkey:false, moment:false */
(function () {
    'use strict';

    angular
            .module('rpkspkRpk')
            .constant('malarkey', malarkey)
            .constant('moment', moment);
})();

(function () {
    'use strict';

    angular
            .module('rpkspkRpk')
            .config(function ($logProvider, snSkrollrProvider) {
                $logProvider.debugEnabled(true);
                snSkrollrProvider.config = {
                  smoothScrolling:true,
                  smoothScrollingDuration:200,
                  mobileDeceleration:0.004
                };
            })
})();

angular.module("rpkspkRpk").run(["$templateCache", function($templateCache) {$templateCache.put("app/fonts/oswald-bold-demo.html","<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional//EN\"\r\n	\"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\"><html xmlns=\"http://www.w3.org/1999/xhtml\" xml:lang=\"en\" lang=\"en\"><head><meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\"><script src=\"http://ajax.googleapis.com/ajax/libs/jquery/1.7.2/jquery.min.js\" type=\"text/javascript\" charset=\"utf-8\"></script><script src=\"specimen_files/easytabs.js\" type=\"text/javascript\" charset=\"utf-8\"></script><link rel=\"stylesheet\" href=\"specimen_files/specimen_stylesheet.css\" type=\"text/css\" charset=\"utf-8\"><link rel=\"stylesheet\" href=\"stylesheet.css\" type=\"text/css\" charset=\"utf-8\"><style type=\"text/css\">\r\n					body{\r\n				font-family: \'oswaldbold\';\r\n							}\r\n		</style><title>Oswald Bold Specimen</title><script type=\"text/javascript\" charset=\"utf-8\">\r\n		$(document).ready(function() {\r\n			$(\'#container\').easyTabs({defaultContent:1});\r\n		});\r\n	</script></head><body><div id=\"container\"><div id=\"header\">Oswald Bold</div><ul class=\"tabs\"><li><a href=\"#specimen\">Specimen</a></li><li><a href=\"#layout\">Sample Layout</a></li><li><a href=\"#glyphs\">Glyphs &amp; Languages</a></li><li><a href=\"#installing\">Installing Webfonts</a></li></ul><div id=\"main_content\"><div id=\"specimen\"><div class=\"section\"><div class=\"grid12 firstcol\"><div class=\"huge\">AaBb</div></div></div><div class=\"section\"><div class=\"glyph_range\">A&#x200B;B&#x200b;C&#x200b;D&#x200b;E&#x200b;F&#x200b;G&#x200b;H&#x200b;I&#x200b;J&#x200b;K&#x200b;L&#x200b;M&#x200b;N&#x200b;O&#x200b;P&#x200b;Q&#x200b;R&#x200b;S&#x200b;T&#x200b;U&#x200b;V&#x200b;W&#x200b;X&#x200b;Y&#x200b;Z&#x200b;a&#x200b;b&#x200b;c&#x200b;d&#x200b;e&#x200b;f&#x200b;g&#x200b;h&#x200b;i&#x200b;j&#x200b;k&#x200b;l&#x200b;m&#x200b;n&#x200b;o&#x200b;p&#x200b;q&#x200b;r&#x200b;s&#x200b;t&#x200b;u&#x200b;v&#x200b;w&#x200b;x&#x200b;y&#x200b;z&#x200b;1&#x200b;2&#x200b;3&#x200b;4&#x200b;5&#x200b;6&#x200b;7&#x200b;8&#x200b;9&#x200b;0&#x200b;&amp;&#x200b;.&#x200b;,&#x200b;?&#x200b;!&#x200b;&#64;&#x200b;(&#x200b;)&#x200b;#&#x200b;$&#x200b;%&#x200b;*&#x200b;+&#x200b;-&#x200b;=&#x200b;:&#x200b;;</div></div><div class=\"section\"><div class=\"grid12 firstcol\"><table class=\"sample_table\"><tr><td>10</td><td class=\"size10\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr><tr><td>11</td><td class=\"size11\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr><tr><td>12</td><td class=\"size12\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr><tr><td>13</td><td class=\"size13\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr><tr><td>14</td><td class=\"size14\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr><tr><td>16</td><td class=\"size16\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr><tr><td>18</td><td class=\"size18\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr><tr><td>20</td><td class=\"size20\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr><tr><td>24</td><td class=\"size24\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr><tr><td>30</td><td class=\"size30\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr><tr><td>36</td><td class=\"size36\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr><tr><td>48</td><td class=\"size48\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr><tr><td>60</td><td class=\"size60\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr><tr><td>72</td><td class=\"size72\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr><tr><td>90</td><td class=\"size90\">abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</td></tr></table></div></div><div class=\"section\" id=\"bodycomparison\"><div id=\"xheight\"><div class=\"fontbody\">&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;&#x25FC;body</div><div class=\"arialbody\">body</div><div class=\"verdanabody\">body</div><div class=\"georgiabody\">body</div></div><div class=\"fontbody\" style=\"z-index:1\">body<span>Oswald Bold</span></div><div class=\"arialbody\" style=\"z-index:1\">body<span>Arial</span></div><div class=\"verdanabody\" style=\"z-index:1\">body<span>Verdana</span></div><div class=\"georgiabody\" style=\"z-index:1\">body<span>Georgia</span></div></div><div class=\"section psample psample_row1\" id=\"\"><div class=\"grid2 firstcol\"><p class=\"size10\"><span>10.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"grid3\"><p class=\"size11\"><span>11.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"grid3\"><p class=\"size12\"><span>12.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"grid4\"><p class=\"size13\"><span>13.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"white_blend\"></div></div><div class=\"section psample psample_row2\" id=\"\"><div class=\"grid3 firstcol\"><p class=\"size14\"><span>14.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"grid4\"><p class=\"size16\"><span>16.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"grid5\"><p class=\"size18\"><span>18.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"white_blend\"></div></div><div class=\"section psample psample_row3\" id=\"\"><div class=\"grid5 firstcol\"><p class=\"size20\"><span>20.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"grid7\"><p class=\"size24\"><span>24.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"white_blend\"></div></div><div class=\"section psample psample_row4\" id=\"\"><div class=\"grid12 firstcol\"><p class=\"size30\"><span>30.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"white_blend\"></div></div><div class=\"section psample psample_row1 fullreverse\"><div class=\"grid2 firstcol\"><p class=\"size10\"><span>10.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"grid3\"><p class=\"size11\"><span>11.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"grid3\"><p class=\"size12\"><span>12.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"grid4\"><p class=\"size13\"><span>13.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"black_blend\"></div></div><div class=\"section psample psample_row2 fullreverse\"><div class=\"grid3 firstcol\"><p class=\"size14\"><span>14.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"grid4\"><p class=\"size16\"><span>16.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"grid5\"><p class=\"size18\"><span>18.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"black_blend\"></div></div><div class=\"section psample fullreverse psample_row3\" id=\"\"><div class=\"grid5 firstcol\"><p class=\"size20\"><span>20.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"grid7\"><p class=\"size24\"><span>24.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"black_blend\"></div></div><div class=\"section psample fullreverse psample_row4\" id=\"\" style=\"border-bottom: 20px #000 solid;\"><div class=\"grid12 firstcol\"><p class=\"size30\"><span>30.</span>Aenean lacinia bibendum nulla sed consectetur. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p></div><div class=\"black_blend\"></div></div></div><div id=\"layout\"><div class=\"section\"><div class=\"grid12 firstcol\"><h1>Lorem Ipsum Dolor</h1><h2>Etiam porta sem malesuada magna mollis euismod</h2><p class=\"byline\">By <a href=\"#link\">Aenean Lacinia</a></p></div></div><div class=\"section\"><div class=\"grid8 firstcol\"><p class=\"large\">Donec sed odio dui. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.</p><h3>Pellentesque ornare sem</h3><p>Maecenas sed diam eget risus varius blandit sit amet non magna. Maecenas faucibus mollis interdum. Donec ullamcorper nulla non metus auctor fringilla. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam id dolor id nibh ultricies vehicula ut id elit.</p><p>Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p><p>Nulla vitae elit libero, a pharetra augue. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Aenean lacinia bibendum nulla sed consectetur.</p><p>Nullam quis risus eget urna mollis ornare vel eu leo. Nullam quis risus eget urna mollis ornare vel eu leo. Maecenas sed diam eget risus varius blandit sit amet non magna. Donec ullamcorper nulla non metus auctor fringilla.</p><h3>Cras mattis consectetur</h3><p>Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Aenean lacinia bibendum nulla sed consectetur. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Cras mattis consectetur purus sit amet fermentum.</p><p>Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam quis risus eget urna mollis ornare vel eu leo. Cras mattis consectetur purus sit amet fermentum.</p></div><div class=\"grid4 sidebar\"><div class=\"box reverse\"><p class=\"last\">Nullam quis risus eget urna mollis ornare vel eu leo. Donec ullamcorper nulla non metus auctor fringilla. Cras mattis consectetur purus sit amet fermentum. Sed posuere consectetur est at lobortis. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p></div><p class=\"caption\">Maecenas sed diam eget risus varius.</p><p>Vestibulum id ligula porta felis euismod semper. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Vestibulum id ligula porta felis euismod semper. Sed posuere consectetur est at lobortis. Maecenas sed diam eget risus varius blandit sit amet non magna. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.</p><p>Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Aenean lacinia bibendum nulla sed consectetur. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Aenean lacinia bibendum nulla sed consectetur. Nullam quis risus eget urna mollis ornare vel eu leo.</p><p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec ullamcorper nulla non metus auctor fringilla. Maecenas faucibus mollis interdum. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.</p></div></div></div><div id=\"glyphs\"><div class=\"section\"><div class=\"grid12 firstcol\"><h1>Language Support</h1><p>The subset of Oswald Bold in this kit supports the following languages:<br>Albanian, Basque, Breton, Chamorro, Danish, Dutch, English, Faroese, Finnish, French, Frisian, Galician, German, Icelandic, Italian, Malagasy, Norwegian, Portuguese, Spanish, Swedish</p><h1>Glyph Chart</h1><p>The subset of Oswald Bold in this kit includes all the glyphs listed below. Unicode entities are included above each glyph to help you insert individual characters into your layout.</p><div id=\"glyph_chart\"><div><p>&amp;#13;</p>&#13;</div><div><p>&amp;#32;</p>&#32;</div><div><p>&amp;#33;</p>&#33;</div><div><p>&amp;#34;</p>&#34;</div><div><p>&amp;#35;</p>&#35;</div><div><p>&amp;#36;</p>&#36;</div><div><p>&amp;#37;</p>&#37;</div><div><p>&amp;#38;</p>&#38;</div><div><p>&amp;#39;</p>&#39;</div><div><p>&amp;#40;</p>&#40;</div><div><p>&amp;#41;</p>&#41;</div><div><p>&amp;#42;</p>&#42;</div><div><p>&amp;#43;</p>&#43;</div><div><p>&amp;#44;</p>&#44;</div><div><p>&amp;#45;</p>&#45;</div><div><p>&amp;#46;</p>&#46;</div><div><p>&amp;#47;</p>&#47;</div><div><p>&amp;#48;</p>&#48;</div><div><p>&amp;#49;</p>&#49;</div><div><p>&amp;#50;</p>&#50;</div><div><p>&amp;#51;</p>&#51;</div><div><p>&amp;#52;</p>&#52;</div><div><p>&amp;#53;</p>&#53;</div><div><p>&amp;#54;</p>&#54;</div><div><p>&amp;#55;</p>&#55;</div><div><p>&amp;#56;</p>&#56;</div><div><p>&amp;#57;</p>&#57;</div><div><p>&amp;#58;</p>&#58;</div><div><p>&amp;#59;</p>&#59;</div><div><p>&amp;#60;</p>&#60;</div><div><p>&amp;#61;</p>&#61;</div><div><p>&amp;#62;</p>&#62;</div><div><p>&amp;#63;</p>&#63;</div><div><p>&amp;#64;</p>&#64;</div><div><p>&amp;#65;</p>&#65;</div><div><p>&amp;#66;</p>&#66;</div><div><p>&amp;#67;</p>&#67;</div><div><p>&amp;#68;</p>&#68;</div><div><p>&amp;#69;</p>&#69;</div><div><p>&amp;#70;</p>&#70;</div><div><p>&amp;#71;</p>&#71;</div><div><p>&amp;#72;</p>&#72;</div><div><p>&amp;#73;</p>&#73;</div><div><p>&amp;#74;</p>&#74;</div><div><p>&amp;#75;</p>&#75;</div><div><p>&amp;#76;</p>&#76;</div><div><p>&amp;#77;</p>&#77;</div><div><p>&amp;#78;</p>&#78;</div><div><p>&amp;#79;</p>&#79;</div><div><p>&amp;#80;</p>&#80;</div><div><p>&amp;#81;</p>&#81;</div><div><p>&amp;#82;</p>&#82;</div><div><p>&amp;#83;</p>&#83;</div><div><p>&amp;#84;</p>&#84;</div><div><p>&amp;#85;</p>&#85;</div><div><p>&amp;#86;</p>&#86;</div><div><p>&amp;#87;</p>&#87;</div><div><p>&amp;#88;</p>&#88;</div><div><p>&amp;#89;</p>&#89;</div><div><p>&amp;#90;</p>&#90;</div><div><p>&amp;#91;</p>&#91;</div><div><p>&amp;#92;</p>&#92;</div><div><p>&amp;#93;</p>&#93;</div><div><p>&amp;#94;</p>&#94;</div><div><p>&amp;#95;</p>&#95;</div><div><p>&amp;#96;</p>&#96;</div><div><p>&amp;#97;</p>&#97;</div><div><p>&amp;#98;</p>&#98;</div><div><p>&amp;#99;</p>&#99;</div><div><p>&amp;#100;</p>&#100;</div><div><p>&amp;#101;</p>&#101;</div><div><p>&amp;#102;</p>&#102;</div><div><p>&amp;#103;</p>&#103;</div><div><p>&amp;#104;</p>&#104;</div><div><p>&amp;#105;</p>&#105;</div><div><p>&amp;#106;</p>&#106;</div><div><p>&amp;#107;</p>&#107;</div><div><p>&amp;#108;</p>&#108;</div><div><p>&amp;#109;</p>&#109;</div><div><p>&amp;#110;</p>&#110;</div><div><p>&amp;#111;</p>&#111;</div><div><p>&amp;#112;</p>&#112;</div><div><p>&amp;#113;</p>&#113;</div><div><p>&amp;#114;</p>&#114;</div><div><p>&amp;#115;</p>&#115;</div><div><p>&amp;#116;</p>&#116;</div><div><p>&amp;#117;</p>&#117;</div><div><p>&amp;#118;</p>&#118;</div><div><p>&amp;#119;</p>&#119;</div><div><p>&amp;#120;</p>&#120;</div><div><p>&amp;#121;</p>&#121;</div><div><p>&amp;#122;</p>&#122;</div><div><p>&amp;#123;</p>&#123;</div><div><p>&amp;#124;</p>&#124;</div><div><p>&amp;#125;</p>&#125;</div><div><p>&amp;#126;</p>&#126;</div><div><p>&amp;#160;</p>&#160;</div><div><p>&amp;#161;</p>&#161;</div><div><p>&amp;#162;</p>&#162;</div><div><p>&amp;#163;</p>&#163;</div><div><p>&amp;#164;</p>&#164;</div><div><p>&amp;#165;</p>&#165;</div><div><p>&amp;#166;</p>&#166;</div><div><p>&amp;#167;</p>&#167;</div><div><p>&amp;#168;</p>&#168;</div><div><p>&amp;#169;</p>&#169;</div><div><p>&amp;#170;</p>&#170;</div><div><p>&amp;#171;</p>&#171;</div><div><p>&amp;#172;</p>&#172;</div><div><p>&amp;#173;</p>&#173;</div><div><p>&amp;#174;</p>&#174;</div><div><p>&amp;#175;</p>&#175;</div><div><p>&amp;#176;</p>&#176;</div><div><p>&amp;#177;</p>&#177;</div><div><p>&amp;#178;</p>&#178;</div><div><p>&amp;#179;</p>&#179;</div><div><p>&amp;#180;</p>&#180;</div><div><p>&amp;#182;</p>&#182;</div><div><p>&amp;#183;</p>&#183;</div><div><p>&amp;#184;</p>&#184;</div><div><p>&amp;#185;</p>&#185;</div><div><p>&amp;#186;</p>&#186;</div><div><p>&amp;#187;</p>&#187;</div><div><p>&amp;#188;</p>&#188;</div><div><p>&amp;#189;</p>&#189;</div><div><p>&amp;#190;</p>&#190;</div><div><p>&amp;#191;</p>&#191;</div><div><p>&amp;#192;</p>&#192;</div><div><p>&amp;#193;</p>&#193;</div><div><p>&amp;#194;</p>&#194;</div><div><p>&amp;#195;</p>&#195;</div><div><p>&amp;#196;</p>&#196;</div><div><p>&amp;#197;</p>&#197;</div><div><p>&amp;#198;</p>&#198;</div><div><p>&amp;#199;</p>&#199;</div><div><p>&amp;#200;</p>&#200;</div><div><p>&amp;#201;</p>&#201;</div><div><p>&amp;#202;</p>&#202;</div><div><p>&amp;#203;</p>&#203;</div><div><p>&amp;#204;</p>&#204;</div><div><p>&amp;#205;</p>&#205;</div><div><p>&amp;#206;</p>&#206;</div><div><p>&amp;#207;</p>&#207;</div><div><p>&amp;#208;</p>&#208;</div><div><p>&amp;#209;</p>&#209;</div><div><p>&amp;#210;</p>&#210;</div><div><p>&amp;#211;</p>&#211;</div><div><p>&amp;#212;</p>&#212;</div><div><p>&amp;#213;</p>&#213;</div><div><p>&amp;#214;</p>&#214;</div><div><p>&amp;#215;</p>&#215;</div><div><p>&amp;#216;</p>&#216;</div><div><p>&amp;#217;</p>&#217;</div><div><p>&amp;#218;</p>&#218;</div><div><p>&amp;#219;</p>&#219;</div><div><p>&amp;#220;</p>&#220;</div><div><p>&amp;#221;</p>&#221;</div><div><p>&amp;#222;</p>&#222;</div><div><p>&amp;#223;</p>&#223;</div><div><p>&amp;#224;</p>&#224;</div><div><p>&amp;#225;</p>&#225;</div><div><p>&amp;#226;</p>&#226;</div><div><p>&amp;#227;</p>&#227;</div><div><p>&amp;#228;</p>&#228;</div><div><p>&amp;#229;</p>&#229;</div><div><p>&amp;#230;</p>&#230;</div><div><p>&amp;#231;</p>&#231;</div><div><p>&amp;#232;</p>&#232;</div><div><p>&amp;#233;</p>&#233;</div><div><p>&amp;#234;</p>&#234;</div><div><p>&amp;#235;</p>&#235;</div><div><p>&amp;#236;</p>&#236;</div><div><p>&amp;#237;</p>&#237;</div><div><p>&amp;#238;</p>&#238;</div><div><p>&amp;#239;</p>&#239;</div><div><p>&amp;#240;</p>&#240;</div><div><p>&amp;#241;</p>&#241;</div><div><p>&amp;#242;</p>&#242;</div><div><p>&amp;#243;</p>&#243;</div><div><p>&amp;#244;</p>&#244;</div><div><p>&amp;#245;</p>&#245;</div><div><p>&amp;#246;</p>&#246;</div><div><p>&amp;#247;</p>&#247;</div><div><p>&amp;#248;</p>&#248;</div><div><p>&amp;#249;</p>&#249;</div><div><p>&amp;#250;</p>&#250;</div><div><p>&amp;#251;</p>&#251;</div><div><p>&amp;#252;</p>&#252;</div><div><p>&amp;#253;</p>&#253;</div><div><p>&amp;#254;</p>&#254;</div><div><p>&amp;#255;</p>&#255;</div><div><p>&amp;#338;</p>&#338;</div><div><p>&amp;#339;</p>&#339;</div><div><p>&amp;#376;</p>&#376;</div><div><p>&amp;#710;</p>&#710;</div><div><p>&amp;#732;</p>&#732;</div><div><p>&amp;#8192;</p>&#8192;</div><div><p>&amp;#8193;</p>&#8193;</div><div><p>&amp;#8194;</p>&#8194;</div><div><p>&amp;#8195;</p>&#8195;</div><div><p>&amp;#8196;</p>&#8196;</div><div><p>&amp;#8197;</p>&#8197;</div><div><p>&amp;#8198;</p>&#8198;</div><div><p>&amp;#8199;</p>&#8199;</div><div><p>&amp;#8200;</p>&#8200;</div><div><p>&amp;#8201;</p>&#8201;</div><div><p>&amp;#8202;</p>&#8202;</div><div><p>&amp;#8208;</p>&#8208;</div><div><p>&amp;#8209;</p>&#8209;</div><div><p>&amp;#8210;</p>&#8210;</div><div><p>&amp;#8211;</p>&#8211;</div><div><p>&amp;#8212;</p>&#8212;</div><div><p>&amp;#8216;</p>&#8216;</div><div><p>&amp;#8217;</p>&#8217;</div><div><p>&amp;#8218;</p>&#8218;</div><div><p>&amp;#8220;</p>&#8220;</div><div><p>&amp;#8221;</p>&#8221;</div><div><p>&amp;#8222;</p>&#8222;</div><div><p>&amp;#8226;</p>&#8226;</div><div><p>&amp;#8230;</p>&#8230;</div><div><p>&amp;#8239;</p>&#8239;</div><div><p>&amp;#8249;</p>&#8249;</div><div><p>&amp;#8250;</p>&#8250;</div><div><p>&amp;#8287;</p>&#8287;</div><div><p>&amp;#8364;</p>&#8364;</div><div><p>&amp;#8482;</p>&#8482;</div><div><p>&amp;#9724;</p>&#9724;</div><div><p>&amp;#64257;</p>&#64257;</div><div><p>&amp;#64258;</p>&#64258;</div><div><p>&amp;#64259;</p>&#64259;</div><div><p>&amp;#64260;</p>&#64260;</div></div></div></div></div><div id=\"specs\"></div><div id=\"installing\"><div class=\"section\"><div class=\"grid7 firstcol\"><h1>Installing Webfonts</h1><p>Webfonts are supported by all major browser platforms but not all in the same way. There are currently four different font formats that must be included in order to target all browsers. This includes TTF, WOFF, EOT and SVG.</p><h2>1. Upload your webfonts</h2><p>You must upload your webfont kit to your website. They should be in or near the same directory as your CSS files.</p><h2>2. Include the webfont stylesheet</h2><p>A special CSS @font-face declaration helps the various browsers select the appropriate font it needs without causing you a bunch of headaches. Learn more about this syntax by reading the <a href=\"http://www.fontspring.com/blog/further-hardening-of-the-bulletproof-syntax\">Fontspring blog post</a> about it. The code for it is as follows:</p><code>\r\n@font-face{ \r\n	font-family: \'MyWebFont\';\r\n	src: url(\'WebFont.eot\');\r\n	src: url(\'WebFont.eot?#iefix\') format(\'embedded-opentype\'),\r\n	     url(\'WebFont.woff\') format(\'woff\'),\r\n	     url(\'WebFont.ttf\') format(\'truetype\'),\r\n	     url(\'WebFont.svg#webfont\') format(\'svg\');\r\n}\r\n</code><p>We\'ve already gone ahead and generated the code for you. All you have to do is link to the stylesheet in your HTML, like this:</p><code>&lt;link rel=&quot;stylesheet&quot; href=&quot;stylesheet.css&quot; type=&quot;text/css&quot; charset=&quot;utf-8&quot; /&gt;</code><h2>3. Modify your own stylesheet</h2><p>To take advantage of your new fonts, you must tell your stylesheet to use them. Look at the original @font-face declaration above and find the property called \"font-family.\" The name linked there will be what you use to reference the font. Prepend that webfont name to the font stack in the \"font-family\" property, inside the selector you want to change. For example:</p><code>p { font-family: \'WebFont\', Arial, sans-serif; }</code><h2>4. Test</h2><p>Getting webfonts to work cross-browser <em>can</em> be tricky. Use the information in the sidebar to help you if you find that fonts aren\'t loading in a particular browser.</p></div><div class=\"grid5 sidebar\"><div class=\"box\"><h2>Troubleshooting<br>Font-Face Problems</h2><p>Having trouble getting your webfonts to load in your new website? Here are some tips to sort out what might be the problem.</p><h3>Fonts not showing in any browser</h3><p>This sounds like you need to work on the plumbing. You either did not upload the fonts to the correct directory, or you did not link the fonts properly in the CSS. If you\'ve confirmed that all this is correct and you still have a problem, take a look at your .htaccess file and see if requests are getting intercepted.</p><h3>Fonts not loading in iPhone or iPad</h3><p>The most common problem here is that you are serving the fonts from an IIS server. IIS refuses to serve files that have unknown MIME types. If that is the case, you must set the MIME type for SVG to \"image/svg+xml\" in the server settings. Follow these instructions from Microsoft if you need help.</p><h3>Fonts not loading in Firefox</h3><p>The primary reason for this failure? You are still using a version Firefox older than 3.5. So upgrade already! If that isn\'t it, then you are very likely serving fonts from a different domain. Firefox requires that all font assets be served from the same domain. Lastly it is possible that you need to add WOFF to your list of MIME types (if you are serving via IIS.)</p><h3>Fonts not loading in IE</h3><p>Are you looking at Internet Explorer on an actual Windows machine or are you cheating by using a service like Adobe BrowserLab? Many of these screenshot services do not render @font-face for IE. Best to test it on a real machine.</p><h3>Fonts not loading in IE9</h3><p>IE9, like Firefox, requires that fonts be served from the same domain as the website. Make sure that is the case.</p></div></div></div></div></div><div id=\"footer\"><p>&copy;2010-2011 Font Squirrel. All rights reserved.</p></div></div></body></html>");
$templateCache.put("app/views/breadcrumbs-prod.html","<div class=\"t_breadcrumbs-prod\"><div class=\"cont-breadcrumbs\"><div class=\"breadcrumbs\"><p><span ncy-breadcrumb=\"\"></span></p></div></div></div>");
$templateCache.put("app/views/breadcrumbs.html","<div class=\"t_breadcrumbs\"><div class=\"cont-breadcrumbs\"><div class=\"breadcrumbs\"><p><span ncy-breadcrumb=\"\"></span></p></div></div></div>");
$templateCache.put("app/views/footer-contacto.html","<footer><div class=\"footer-contacto\"><div class=\"cont-footer-contacto\"><div class=\"ciudad\" ng-class=\"{uno: contacto.oficinas.length==1}\" data-ng-repeat=\"oficina in contacto.oficinas | limitTo:3\"><div class=\"tx-ciudad\"><h3 data-ng-bind=\"oficina.nombre\"></h3><p ng-bind=\"oficina.direccion\"></p><p>Teléfono: <span ng-bind=\"oficina.telefono\"></span></p></div><div class=\"mapa-oficina\"><img ng-src=\"https://maps.googleapis.com/maps/api/staticmap?center={{oficina.latitud}},{{oficina.longitud}}&zoom=15&size=150x120&maptype=roadmap &markers=icon:http://rpk.indomita.bo/app/img/icons/icon-marker.contacto.png|{{oficina.latitud}},{{oficina.longitud}}&key=AIzaSyDtMTZcjHA50Jmksbi7ybnqa8MYX5_zu_4\" alt=\"\"></div></div></div></div></footer>");
$templateCache.put("app/views/footer-mapa.html","<footer><div class=\"footer-mapa\"><div class=\"bt-mapa\"><div class=\"cont-bt-mapa\"><div class=\"boton-mapa\"><a class=\"bt-transparente\" href=\"#/informacion\">SOLICITAR INFOrmación</a></div><div class=\"boton-mapa\"><a class=\"bt-transparente\">descargar tarifario</a></div></div></div><div class=\"icons-mapa\"><div class=\"cont-icons-mapa\"><div class=\"icono\"><img src=\"app/img/icons/icon-mapa-ocupado.svg\"><h3>OCUPADO</h3></div><div class=\"icono\"><img src=\"app/img/icons/icon-mapa-pronto.svg\"><h3>PRONTO A LIBERARSE</h3></div><div class=\"icono\"><img src=\"app/img/icons/icon-mapa-disponible.svg\"><h3>DISPONIBLE</h3></div></div></div></div></footer>");
$templateCache.put("app/views/footer.html","<footer><div class=\"footer\"><div class=\"cont-footer\"><div class=\"logo\"><img src=\"app/img/logo-rpk.svg\"></div><div class=\"tx-footer\"><p data-ng-bind=\"footeroficinas.direccion\">Edificio Parque 18, Piso 3 Oficina 3B1, Calacoto. La Paz - Bolivia.</p><p>Teléfono: <span data-ng-bind=\"footeroficinas.telefono\"></span> / Email: <span data-ng-bind=\"footeroficinas.email\"></span></p></div><div class=\"social\"><a href=\"https://www.facebook.com/rpkinstore/home\" target=\"_blank\"><img src=\"app/img/icons/icon-facebook.svg\"></a></div></div></div></footer>");
$templateCache.put("app/views/header.html","<header><div class=\"header\"><div class=\"cont-header\"><div class=\"logo\"><a href=\"#/\"><img src=\"app/img/logo-rpk.svg\"></a></div><ul><a href=\"#/\"><li>INICIO</li></a> <a href=\"\"><li class=\"mbt-prod\" data-ng-init=\"headerc.vermDesp = false\" data-ng-click=\"headerc.vermDesp = !headerc.vermDesp\" data-deep-blur=\"headerc.vermDesp=false\">MAPA DE PRODUCTOS<ul class=\"mdesp-prod\" data-ng-if=\"headerc.vermDesp\"><a href=\"#/productos\"><li>Todos</li></a> <a data-ng-repeat=\"mproducto in headerc.mproductos\" href=\"#/productos/{{mproducto.id}}\"><li>{{mproducto.nombre}}</li></a></ul></li></a> <a href=\"#/quienessomos\"><li>QUIENES SOMOS</li></a> <a href=\"#/contacto\"><li>CONTACTO</li></a> <a href=\"http://cliente.rpk.com.bo\" target=\"_blank\"><li>LOG IN</li></a></ul></div><div class=\"search\" data-ng-init=\"search = false\"><div class=\"search\"><div class=\"icono\"><a href=\"#/search\"><img src=\"app/img/icons/icon-search-ini.svg\"></a></div></div></div></div><div class=\"header-xs\"><div class=\"cont-header\" data-ng-init=\"menuxs = false\"><div class=\"bt-menu\" data-ng-click=\"menuxs = !menuxs\"><div class=\"icono\"><img src=\"app/img/icons/icon-menu.png\"></div></div><div class=\"logo\"><a href=\"#/\"><img src=\"app/img/logo-rpk.svg\"></a></div><ul data-ng-show=\"menuxs\"><a href=\"#/\"><li>INICIO</li></a> <a href=\"#/productos\"><li>MAPA DE PRODUCTOS</li></a> <a href=\"#/quienessomos\"><li>QUIENES SOMOS</li></a> <a href=\"#/contacto\"><li>CONTACTO</li></a> <a href=\"http://cliente.rpk.com.bo\" target=\"_blank\"><li>LOG IN</li></a></ul></div><div class=\"search\"><div class=\"icono\"><a href=\"#/search\"><img src=\"app/img/icons/icon-search-mobile.svg\"></a></div></div></div></header>");
$templateCache.put("app/views/search.html","<div ng-include=\"\" src=\"\'app/views/header.html\'\"></div><div ng-include=\"\" src=\"\'app/views/breadcrumbs.html\'\"></div><div class=\"pagina pag-buscador\"><div class=\"cont-buscador\"><h1 class=\"icon-search\">BUSCAR</h1><p>Ingresa el texto que deseas buscar en el siguiente campo campo.</p><div class=\"search\"><input type=\"text\" class=\"input-formulario\" placeholder=\"Busca productos\" data-ng-model=\"bsq.buscar\" data-ng-change=\"bsq.verAC();\"><ul class=\"autcomplete\" data-ng-if=\"bsq.mAC\"><li data-ng-repeat=\"item in bsq.resultados\"><a href=\"#/informacion/{{item.registro.id}}\"><span class=\"titulo\" data-ng-bind-html=\"item.registro.alias | highlight:bsq.buscar\"></span> <span class=\"direccion\" data-ng-bind-html=\"item.registro.direccion | highlight:bsq.buscar\"></span></a></li></ul></div></div></div><div ng-include=\"\" src=\"\'app/views/footer.html\'\"></div>");
$templateCache.put("app/views/subheader.html","<div class=\"subheader\"><div class=\"cont-subheader\"><div class=\"fila1\"><h1 class=\"titulo_res\">MIS PRODUCTOS</h1><div class=\"breadcrumbs\"><p><span ncy-breadcrumb=\"\"></span></p></div><div class=\"derecha\"><div class=\"boton-mapa\"><a class=\"bt-transparente\" href=\"{{productos.tarifario[0].contenido}}\" target=\"_blank\" data-ng-if=\"productos.tarifario[0].contenido\"><span>descargar</span> tarifario</a></div><div class=\"lista-ciudades\" data-deep-blur=\"productos.verCiudades=false\"><label class=\"deplegar-lista\" data-ng-click=\"productos.verCiudades = !productos.verCiudades\" data-ng-class=\"{active: productos.verCiudades}\"><a href=\"\" id=\"labelCiudad\">{{productos.nomCiudadSel}}</a> <span></span></label><ul id=\"comboCiudad\" data-ng-if=\"productos.verCiudades\" class=\"lista-elegir\"><li data-ng-repeat=\"ciudad in productos.ciudades\" data-ng-click=\"productos.selciudadmapa(ciudad);\">{{ciudad.nombre}}</li></ul></div></div></div><div class=\"fila2\"><div class=\"botones_info\"><div class=\"bt-info estados\" data-ng-class=\"{active: productos.estados}\" data-ng-click=\"productos.estados = !productos.estados; productos.switches = false;\"><p>INFORMACIÓN</p></div><div class=\"bt-info switches\" data-ng-class=\"{active: productos.switches}\" data-ng-click=\"productos.switches = !productos.switches; productos.estados = false;\"><p>PRODUCTOS</p></div></div><div class=\"icons-mapa\" data-ng-if=\"productos.estados || productos.pantallaW > 992\"><div class=\"cont-icons-mapa\"><p>Estado de los productos</p><div class=\"icono disponible\"><h3>Disponible</h3></div><div class=\"icono pronto\"><h3>Pronto a liberarse</h3></div><div class=\"icono ocupado\"><h3>Ocupado</h3></div></div></div><div class=\"sw-productos\" data-ng-if=\"productos.switches || productos.pantallaW > 992\"><p>Seleccione uno o más productos</p><div class=\"cont-3\" style=\"min-width: {{productos.categoriasprod.length * 72}}px\"><div class=\"bt-vallas box-switch\" data-ng-repeat=\"categoria in productos.categoriasprod\" data-ng-class=\"{active: productos.swactive(categoria)}\"><p data-ng-bind=\"categoria.nombre\"></p><div class=\"switch-style sw-vallas\" style=\"background: url(\'{{productos.buscarsw(categoria)}}\') no-repeat 5px 50%; background-size: 25px auto\"><div class=\"icono\"><img data-ng-src=\"{{productos.buscarsw(categoria)}}\"></div><div class=\"switch\"><input id=\"{{categoria.nombre + \'1\'}}\" class=\"cmn-toggle cmn-toggle-round\" type=\"checkbox\"> <label for=\"{{categoria.nombre + \'1\'}}\"></label></div><div class=\"switch\"><input id=\"{{categoria.nombre + \'2\'}}\" class=\"cmn-toggle cmn-toggle-round-flat\" type=\"checkbox\" data-ng-model=\"productos.swProd[categoria.id]\" data-ng-change=\"productos.changeSwitches(categoria)\"> <label for=\"{{categoria.nombre + \'2\'}}\"></label></div><div class=\"switch\"><input id=\"{{categoria.nombre + \'3\'}}\" class=\"cmn-toggle cmn-toggle-yes-no\" type=\"checkbox\"> <label for=\"{{categoria.nombre + \'3\'}}\" data-on=\"Yes\" data-off=\"No\"></label></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/views/contacto/contacto.html","<div ng-include=\"\" src=\"\'app/views/header.html\'\"></div><div ng-include=\"\" src=\"\'app/views/breadcrumbs.html\'\"></div><div class=\"pag-contacto pagina\"><div class=\"cont-contacto\"><h1 class=\"icon-contacto\">CONTACTO</h1><p>{{contacto.mensajeform}}</p><div class=\"cont-form\"><div class=\"inputs\"><input input-animate=\"\" type=\"text\" data-ng-pattern=\"/^[a-zA-Zñáéíóú\\s]*.{3}$/\" placeholder=\"Nombre completo\" class=\"input-formulario\" data-ng-model=\"contacto.nombre\" required=\"\"> <label>Nombre completo</label> <input input-animate=\"\" type=\"email\" placeholder=\"Correo electrónico\" class=\"input-formulario\" data-ng-pattern=\'/^(([^<>()[\\]\\\\.,;:\\s@\\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\\"]+)*)|(\\\".+\\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\' data-ng-model=\"contacto.email\" required=\"\"> <label>Correo electrónico</label> <input input-animate=\"\" type=\"tel\" data-ng-pattern=\"/^[0-9].{6,8}$/\" placeholder=\"Teléfono\" class=\"input-formulario\" data-ng-model=\"contacto.telefono\" required=\"\"> <label>Teléfono</label> <input input-animate=\"\" type=\"text\" data-ng-pattern=\"/^[a-zA-Zñáéíóú\\s]*.{3}$/\" placeholder=\"Empresa (Opcional)\" class=\"input-formulario\" data-ng-model=\"contacto.empresa\"> <label>Nombre de empresa</label></div><div class=\"mensaje\"><textarea input-animate=\"\" name=\"\" id=\"\" cols=\"30\" rows=\"3\" placeholder=\"Su mensaje...\" class=\"input-formulario\" data-ng-pattern=\"/^[a-zA-Zñáéíóú\\s]*.{3}$/\" data-ng-model=\"contacto.mensaje\" required=\"\"></textarea> <label>Mensaje</label><div class=\"cont-captcha\"><div vc-recaptcha=\"\" theme=\"\'light\'\" key=\"contacto.model.key\" on-create=\"contacto.setWidgetId(widgetId)\" on-success=\"contacto.setResponse(response)\" on-expire=\"contacto.cbExpiration()\"></div><div class=\"bt-refresh\" title=\"Recargar captcha\" onclick=\"location.reload();\"></div></div></div></div><button ng-click=\"contacto.enviarContacto()\" class=\"bt-transparente\" data-ng-if=\"contacto.enableSubmit\">ENVIAR</button></div></div><div ng-include=\"\" src=\"\'app/views/footer-contacto.html\'\"></div>");
$templateCache.put("app/views/inicio/inicio.html","<div ng-include=\"\" src=\"\'app/views/header.html\'\"></div><div class=\"loader\" data-ng-class=\"{esipad : dispositivo == \'iPad\'}\"><div class=\"cont_loader\"><p id=\"percent_loading\">{{inicio.percentLoaded}} %</p></div></div><div sn-skrollr=\"\" class=\"gradient-sec\" data-ng-init=\"deg = false\" data-ng-class=\"{esipad : dispositivo == \'iPad\'}\" data-0=\"display:none; opacity:0\" data-2000=\"display:block; opacity:1\" data-3500=\"display:block; opacity:1\" data-4000=\"display:none; opacity:0\"><div class=\"cerrar\" data-ng-click=\"deg = false\"></div><div class=\"bt-cerrar-info\" data-ng-click=\"deg = false\" data-ng-show=\"deg\"></div><div class=\"bt-animado\" data-ng-click=\"deg = !deg\" data-ng-show=\"!deg\"><h2>PASARELAS</h2><img src=\"app/img/icons/icon-boton-pasarelas.svg\"></div><div class=\"cont-sec\"><div class=\"bt-vallas\" data-ng-show=\"deg\"><img src=\"app/img/icons/icon-boton-pasarelas.svg\"></div><div class=\"des-vallas\" data-ng-class=\"{active: deg}\"><h1>{{inicio.contenido[0]}}</h1><p>{{inicio.contenido[1]}}</p><a href=\"#/productos/3\" class=\"bt-transparente\">VER NUESTRAS PASARELAS</a></div></div><div class=\"fondo-grad\" data-ng-class=\"{active: deg}\"></div></div><div sn-skrollr=\"\" class=\"gradient-sec\" data-ng-init=\"deg = false\" data-ng-class=\"{esipad : dispositivo == \'iPad\'}\" data-0=\"display:none; opacity:0\" data-6000=\"display:block; opacity:1\" data-7500=\"display:block; opacity:1\" data-8000=\"display:none; opacity:0\"><div class=\"cerrar\" data-ng-click=\"deg = false\"></div><div class=\"bt-cerrar-info\" data-ng-click=\"deg = false\" data-ng-show=\"deg\"></div><div class=\"bt-animado\" data-ng-click=\"deg = !deg\" data-ng-show=\"!deg\"><h2>PANTALLAS</h2><img src=\"app/img/icons/icon-boton-pantallas.svg\"></div><div class=\"cont-sec\"><div class=\"bt-vallas\" data-ng-show=\"deg\"><img src=\"app/img/icons/icon-boton-pantallas.svg\"></div><div class=\"des-vallas\" data-ng-class=\"{active: deg}\"><h1>{{inicio.contenido[2]}}</h1><p>{{inicio.contenido[3]}}</p><a href=\"#/productos/2\" class=\"bt-transparente\">VER NUESTRAS PANTALLAS</a></div></div><div class=\"fondo-grad\" data-ng-class=\"{active: deg}\"></div></div><div sn-skrollr=\"\" class=\"gradient-sec\" data-ng-init=\"deg = false\" data-ng-class=\"{esipad : dispositivo == \'iPad\'}\" data-0=\"display:none; opacity:0\" data-10000=\"display:block; opacity:1\" data-11500=\"display:block; opacity:1\" data-12000=\"display:none; opacity:0\"><div class=\"cerrar\" data-ng-click=\"deg = false\"></div><div class=\"bt-cerrar-info\" data-ng-click=\"deg = false\" data-ng-show=\"deg\"></div><div class=\"bt-animado\" data-ng-click=\"deg = !deg\" data-ng-show=\"!deg\"><h2>VALLAS</h2><img src=\"app/img/icons/icon-boton-vallas.svg\"></div><div class=\"cont-sec\"><div class=\"bt-vallas\" data-ng-show=\"deg\"><img src=\"app/img/icons/icon-boton-vallas.svg\"></div><div class=\"des-vallas\" data-ng-class=\"{active: deg}\"><h1>{{inicio.contenido[4]}}</h1><p>{{inicio.contenido[5]}}</p><a href=\"#/productos/1\" class=\"bt-transparente\">VER NUESTRAS VALLAS</a></div></div><div class=\"fondo-grad\" data-ng-class=\"{active: deg}\"></div></div><div sn-skrollr=\"\" class=\"gradient-sec\" data-ng-init=\"deg = false\" data-ng-class=\"{esipad : dispositivo == \'iPad\'}\" data-0=\"display:none; opacity:0\" data-14000=\"display:block; opacity:1\" data-15500=\"display:block; opacity:1\" data-16000=\"display:none; opacity:0\"><div class=\"cerrar\" data-ng-click=\"deg = false\"></div><div class=\"bt-cerrar-info\" data-ng-click=\"deg = false\" data-ng-show=\"deg\"></div><div class=\"bt-animado\" data-ng-click=\"deg = !deg\" data-ng-show=\"!deg\"><h2>PANTALLAS LED</h2><img src=\"app/img/icons/icon-boton-led.svg\"></div><div class=\"cont-sec\"><div class=\"bt-vallas\" data-ng-show=\"deg\"><img src=\"app/img/icons/icon-boton-led.svg\"></div><div class=\"des-vallas\" data-ng-class=\"{active: deg}\"><h1>{{inicio.contenido[6]}}</h1><p>{{inicio.contenido[7]}}</p><a href=\"#/productos/4\" class=\"bt-transparente\">VER NUESTRAS PANTALLAS LED</a></div></div><div class=\"fondo-grad\" data-ng-class=\"{active: deg}\"></div></div><div id=\"container\" class=\"parallax\" data-ng-class=\"{esipad : dispositivo == \'iPad\'}\"><div class=\"icon-scroll\"></div><ul id=\"scene\" class=\"scene border fill\"><div class=\"bt-vallas\" data-ng-click=\"deg = !deg\"><img src=\"app/img/icons/icon-boton-vallas.svg\"></div><li class=\"layer expand-width fondo_0 imag100\" id=\"inicio\"><div sn-skrollr=\"\" class=\"par_montanhas\" data-0=\"transform:translateZ(0px);\" data-4000=\"transform:translateZ(400px);opacity:1;\" data-4001=\"opacity:0;\"></div></li><li class=\"layer expand-width fondo_1 imag100\"><div sn-skrollr=\"\" class=\"par_ciudad\" data-0=\"transform:translateZ(0px);\" data-4000=\"transform:translateZ(940px);opacity:1;\" data-4001=\"opacity:0;\"></div><div sn-skrollr=\"\" class=\"par_ciudad2\" data-0=\"transform:translateZ(0px); opacity:0;\" data-2000=\"transform:translateZ(0px); opacity:0;\" data-2001=\"transform:translateZ(0px); opacity:1;\" data-4000=\"transform:translateZ(940px);opacity:1;\" data-4001=\"opacity:0;\"></div><div sn-skrollr=\"\" class=\"par_ciudad3\" data-0=\"transform:translateZ(0px); opacity:0;\" data-3000=\"transform:translateZ(0px); opacity:0;\" data-3001=\"transform:translateZ(0px); opacity:1;\" data-4000=\"transform:translateZ(940px); opacity:1;\" data-4001=\"opacity:0;\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"par_ventana\" data-0=\"transform:translateZ(0px);\" data-4000=\"transform:translateZ(2560px);opacity:1;\" data-4001=\"opacity:0;\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"par_escritorio\" data-0=\"transform:translateZ(0px);\" data-4000=\"transform:translateZ(5120px);opacity:1;\" data-4001=\"opacity:0;\" data-ng-click=\"skrollrDestroy();\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc2_fondo\" data-0=\"opacity:0;\" data-4000=\"opacity:0;\" data-4001=\"transform:translateZ(0px);opacity:1;\" data-8000=\"transform:translateZ(800px);opacity:1;\" data-8001=\"opacity:0;\"><img src=\"app/img/rpk2/pantalla.gif\"></div><div sn-skrollr=\"\" class=\"sc2_fondo2\" data-0=\"opacity:0;\" data-6500=\"opacity:0;\" data-6501=\"transform:translateZ(0px);opacity:1;\" data-8000=\"transform:translateZ(800px);opacity:1;\" data-8001=\"opacity:0;\"><img src=\"app/img/rpk2/pantalla.gif\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc2_pantalla\" data-0=\"opacity:0;\" data-4000=\"opacity:0;\" data-4001=\"transform:translateZ(0px);opacity:1;\" data-8000=\"transform:translateZ(960px);opacity:1;\" data-8001=\"opacity:0;\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc2_maleta\" data-0=\"opacity:0;\" data-4000=\"opacity:0;\" data-4001=\"transform:translateZ(0px);opacity:1;\" data-8000=\"transform:translateZ(1280px);opacity:1;\" data-8001=\"opacity:0;\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc2_letrero\" data-0=\"opacity:0;\" data-4000=\"opacity:0;\" data-4001=\"transform:translateZ(0px);opacity:1;\" data-8000=\"transform:translateZ(2560px);opacity:1;\" data-8001=\"opacity:0;\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc2_ninho\" data-0=\"opacity:0;\" data-4000=\"opacity:0;\" data-4001=\"transform:translateZ(0px);opacity:1;\" data-8000=\"transform:translateZ(5120px);opacity:1;\" data-8001=\"opacity:0;\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc2_pareja\" data-0=\"opacity:0;\" data-4000=\"opacity:0;\" data-4001=\"transform:translateZ(0px);opacity:1;\" data-8000=\"transform:translateZ(10240px);opacity:1;\" data-8001=\"opacity:0;\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc3_cielo\" data-0=\"opacity:0;\" data-8000=\"opacity:0;\" data-8001=\"transform:translateZ(0px);opacity:1;\" data-12000=\"transform:translateZ(80px);opacity:1;\" data-12001=\"opacity:0;\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc3_edificioFondo\" data-0=\"opacity:0;\" data-8000=\"opacity:0;\" data-8001=\"transform:translateZ(0px);opacity:1;\" data-12000=\"transform:translateZ(960px);opacity:1;\" data-12001=\"opacity:0;\"></div><div sn-skrollr=\"\" class=\"sc3_edificioFondo_2\" data-0=\"transform:translateZ(0px); opacity:0;\" data-10000=\"transform:translateZ(0px); opacity:0;\" data-10001=\"transform:translateZ(0px); opacity:1;\" data-12000=\"transform:translateZ(960px);opacity:1;\" data-12001=\"opacity:0;\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc3_edificiosFondo\" data-0=\"opacity:0;\" data-8000=\"opacity:0;\" data-8001=\"transform:translateZ(0px);opacity:1;\" data-12000=\"transform:translateZ(1100px);opacity:1;\" data-12001=\"opacity:0;\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc3_ciudad\" data-0=\"opacity:0;\" data-8000=\"opacity:0;\" data-8001=\"transform:translateZ(0px);opacity:1;\" data-12000=\"transform:translateZ(1200px);opacity:1;\" data-12001=\"opacity:0;\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc3_edificios\" data-0=\"opacity:0;\" data-8000=\"opacity:0;\" data-8001=\"transform:translateZ(0px);opacity:1;\" data-12000=\"transform:translateZ(1300px);opacity:1;\" data-12001=\"opacity:0;\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc3_arbol\" data-0=\"opacity:0;\" data-8000=\"opacity:0;\" data-8001=\"transform:translateZ(0px);opacity:1;\" data-12000=\"transform:translateZ(1500px);opacity:1;\" data-12001=\"opacity:0;\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc3_cables\" data-0=\"opacity:0;\" data-8000=\"opacity:0;\" data-8001=\"transform:translateZ(0px);opacity:1;\" data-12000=\"transform:translateZ(2000px);opacity:1;\" data-12001=\"opacity:0;\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc4_cielo\" data-0=\"opacity:0;\" data-12000=\"opacity:0;\" data-12001=\"transform:translateZ(0px);opacity:1;\" data-16000=\"transform:translateZ(80px);\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc4_edificios\" data-0=\"opacity:0;\" data-12000=\"opacity:0;\" data-12001=\"transform:translateZ(0px);opacity:1;\" data-16000=\"transform:translateZ(600px);\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc4_ciudad_1\" data-0=\"opacity:0;\" data-12000=\"opacity:0;\" data-12001=\"transform:translateZ(0px);opacity:1;\" data-14000=\"transform:translateZ(500px);opacity:1;\" data-14001=\"transform:translateZ(500px);opacity:0;\" data-16000=\"transform:translateZ(800px);\"><img src=\"app/img/rpk4/pantalla-led.gif\"></div><div sn-skrollr=\"\" class=\"sc4_ciudad_2\" data-0=\"transform:translateZ(0px);opacity:0;\" data-14000=\"transform:translateZ(0px);opacity:0;\" data-14001=\"transform:translateZ(0px);opacity:1;\" data-16000=\"transform:translateZ(800px);\"><img src=\"app/img/rpk4/pantalla-led.gif\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"sc4_baranda\" data-0=\"opacity:0;\" data-12000=\"opacity:0;\" data-12001=\"transform:translateZ(0px);opacity:1;\" data-16000=\"transform:translateZ(1400px);\"></div></li><li class=\"layer expand-width imag100\"><div sn-skrollr=\"\" class=\"pantalla-final\" data-0=\"opacity:0;\" data-16000=\"opacity:0;\" data-16001=\"opacity:1;\"><div class=\"cont-final\"><img src=\"app/img/logo-rpk.svg\"><div class=\"c-ciudades\"><div class=\"l-ciudad\" ng-class=\"{uno: inicio.oficinas.length==1}\" data-ng-repeat=\"oficina in inicio.oficinas | limitTo:1\"><h3 data-ng-bind=\"oficina.nombre\"></h3><p ng-bind=\"oficina.direccion\"></p><p>Teléfono: <span ng-bind=\"oficina.telefono\">7645 234</span></p></div></div></div></div></li></ul></div><div class=\"gradient-sec gradient-sec-xs\" data-ng-init=\"degXs = false\" data-ng-class=\"{esipad : dispositivo == \'iPad\'}\"><div class=\"cont-sec\"><div class=\"bt-vallas\" data-ng-click=\"degXs = !degXs\"><img src=\"app/img/icons/icon-boton-pasarelas.svg\" data-ng-if=\"escenaActiva == 1\"> <img src=\"app/img/icons/icon-boton-pantallas.svg\" data-ng-if=\"escenaActiva == 2\"> <img src=\"app/img/icons/icon-boton-vallas.svg\" data-ng-if=\"escenaActiva == 3\"> <img src=\"app/img/icons/icon-boton-led.svg\" data-ng-if=\"escenaActiva == 4\"></div><div class=\"des-vallas\" data-ng-class=\"{active: degXs}\"><div data-ng-if=\"escenaActiva == 1\"><h1>{{inicio.contenido[0]}}</h1><p>{{inicio.contenido[1]}}</p><a href=\"#/productos/3\" class=\"bt-transparente\">VER NUESTRAS PASARELAS</a></div><div data-ng-if=\"escenaActiva == 2\"><h1>{{inicio.contenido[2]}}</h1><p>{{inicio.contenido[3]}}</p><a href=\"#/productos/2\" class=\"bt-transparente\">VER NUESTRAS PANTALLAS</a></div><div data-ng-if=\"escenaActiva == 3\"><h1>{{inicio.contenido[4]}}</h1><p>{{inicio.contenido[5]}}</p><a href=\"#/productos/1\" class=\"bt-transparente\">VER NUESTRAS VALLAS</a></div><div data-ng-if=\"escenaActiva == 4\"><h1>{{inicio.contenido[6]}}</h1><p>{{inicio.contenido[7]}}</p><a href=\"#/productos/4\" class=\"bt-transparente\">VER NUESTRAS PANTALLAS LED</a></div></div></div><div class=\"fondo-grad\" data-ng-class=\"{active: degXs}\"></div></div><div class=\"parallax-xs\" data-ng-init=\"escenaActiva = 1\" data-ng-class=\"{esipad : dispositivo == \'iPad\'}\"><div class=\"escenaXs escena4\" data-ng-if=\"escenaActiva == 4\"></div><div class=\"escenaXs escena3\" data-ng-if=\"escenaActiva == 3\"></div><div class=\"escenaXs escena2\" data-ng-if=\"escenaActiva == 2\"></div><div class=\"escenaXs escena1\" data-ng-if=\"escenaActiva == 1\"></div><div class=\"botones-nav\" data-ng-class=\"{inactive: degXs}\"><div class=\"bt-nav-circle\" data-ng-class=\"{active: escenaActiva == 1 }\" data-ng-click=\"escenaActiva = 1\"><span></span></div><div class=\"bt-nav-circle\" data-ng-class=\"{active: escenaActiva == 2 }\" data-ng-click=\"escenaActiva = 2\"><span></span></div><div class=\"bt-nav-circle\" data-ng-class=\"{active: escenaActiva == 3 }\" data-ng-click=\"escenaActiva = 3\"><span></span></div><div class=\"bt-nav-circle\" data-ng-class=\"{active: escenaActiva == 4 }\" data-ng-click=\"escenaActiva = 4\"><span></span></div></div></div><div ng-include=\"\" src=\"\'app/views/footer.html\'\"></div>");
$templateCache.put("app/views/login/login.html","<div ng-include=\"\" src=\"\'app/views/header.html\'\"></div><div ng-include=\"\" src=\"\'app/views/breadcrumbs.html\'\"></div><div class=\"pagina pag-login\"><div class=\"cont-login\"><h1 class=\"icon-login\">LOGIN</h1><p>Error</p><div class=\"input-login clearfix\"><input type=\"text\" placeholder=\"\" class=\"input-formulario\"><div class=\"icon-input-login\"><img src=\"app/img/icons/icon-input-login.svg\"></div></div><label>Nombre de usuario</label><div class=\"input-login clearfix\"><input type=\"password\" placeholder=\"\" class=\"input-formulario\"><div class=\"icon-input-login\"><img src=\"app/img/icons/icon-input-login.svg\"></div></div><label>Contraseña</label><div class=\"cont-recordarme\"><div class=\"radio-style radio-recordarme\"><div class=\"switch\"><input id=\"rad-recordarme-1\" class=\"cmn-toggle cmn-toggle-round\" type=\"checkbox\"> <label for=\"rad-recordarme-1\"></label></div><div class=\"switch\"><input id=\"rad-recordarme-2\" class=\"cmn-toggle cmn-toggle-round-flat\" type=\"checkbox\"> <label for=\"rad-recordarme-2\"></label></div><div class=\"switch\"><input id=\"rad-recordarme-3\" class=\"cmn-toggle cmn-toggle-yes-no\" type=\"checkbox\"> <label for=\"rad-recordarme-3\" data-on=\"Yes\" data-off=\"No\"></label></div></div><p>Recordarme</p></div><p class=\"olvidaste\">¿Olvidaste tu contraseña?</p><a href=\"#/\" class=\"bt-volver\">Volver RPK</a> <button class=\"bt-transparente\">ENTRAR</button></div></div><div ng-include=\"\" src=\"\'app/views/footer.html\'\"></div>");
$templateCache.put("app/views/mapaproductos/mapaproductos.html","<div ng-include=\"\" src=\"\'app/views/header.html\'\"></div><div class=\"contenedor_mapa row\"><div class=\"breadcumbs\"><p><b><a href=\"/#/inicio\">Inicio</a> > Mapa de productos</b></p></div><h1 class=\"titulo\">MAPA DE PRODUCTOS</h1><div class=\"filtro\" style=\"height: 1px; float: right;\"><div class=\"caja\" style=\"overflow: hidden\"><button type=\"button\" class=\"btn btn-primary btn_filtro\" style=\"float: right; margin:9px ; z-index: 10000009;\" data-toggle=\"modal\" data-target=\"#myModal\">FILTROS</button></div></div><script type=\"text/javascript\">\r\n    $(document).ready(function () {\r\n        var punto = new google.maps.LatLng(-16.495859,-68.133529);\r\n        var myOptions = {\r\n            zoom: 17, center: punto, mapTypeId: google.maps.MapTypeId.ROADMAP\r\n        };\r\n        var map = new google.maps.Map(document.getElementById(\"mostrarMapa\"),  myOptions);\r\n        var marker = new google.maps.Marker({\r\n            position:punto,\r\n            map: map,\r\n            title:\"Título del mapa\"});\r\n    });\r\n    </script><div class=\"mapa\" id=\"mostrarMapa\" style=\"z-index: -99999;\"></div></div><div class=\"modal fade\" id=\"myModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" style=\"background-color: rgba(0, 0, 0, 0.6);\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Filtros</h4></div><div class=\"modal-body\"><div class=\"row\"><p>Elije una ciudad para navegar</p><select name=\"ciudad\" id=\"ciudad\"><option value=\"LP\">La Paz</option><option value=\"CH\">Cochabamba</option><option value=\"SC\">Santa Cruz</option></select><p>Active o desactive el tipo de producto que desea ver en el mapa</p><div class=\"campo\"><div class=\"etiqueta\">Vallas Publicitarias</div><div class=\"onoffswitch switch\"><input type=\"checkbox\" name=\"onoffswitch\" class=\"onoffswitch-checkbox\" id=\"myonoffswitch\" checked=\"\"> <label class=\"onoffswitch-label\" for=\"myonoffswitch\"></label></div></div><div class=\"campo\"><div class=\"etiqueta\">Publicidad HD</div><div class=\"onoffswitch switch\"><input type=\"checkbox\" name=\"onoffswitch\" class=\"onoffswitch-checkbox\" id=\"myonoffswitch2\" checked=\"\"> <label class=\"onoffswitch-label\" for=\"myonoffswitch2\"></label></div></div><div class=\"campo\"><div class=\"etiqueta\">Pasarelas</div><div class=\"onoffswitch switch\"><input type=\"checkbox\" name=\"onoffswitch\" class=\"onoffswitch-checkbox\" id=\"myonoffswitch3\" checked=\"\"> <label class=\"onoffswitch-label\" for=\"myonoffswitch3\"></label></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\">Aceptar</button></div></div></div></div><div ng-include=\"\" src=\"\'app/views/footer.html\'\"></div>");
$templateCache.put("app/views/pasarelas/pasarelas.html","<div ng-include=\"\" src=\"\'app/views/header.html\'\"></div><div class=\"contenedor_productos2 container-fluid\"><div class=\"breadcumbs\"><p><b><a href=\"/#/inicio\">Inicio</a> > <a href=\"/#/productos\">Productos</a> > Pasarelas</b></p></div><div class=\"row\" style=\"height: 100%;\"><div class=\"cont_izq\"><div class=\"titulo_producto\"><div class=\"icono\"><img src=\"app/icons/icono_pasarela.svg\" class=\"icono\" alt=\"\"></div><div class=\"titulo\"><h1>PASARELAS</h1></div></div><p>Daa chasy potatoooo underweaaar underweaaar. Tank yuuu! potatoooo bee do bee do bee do uuuhhh uuuhhh belloo! Belloo! me want bananaaa! Pepete hahaha belloo! Chasy bappleees butt tatata bala tu jeje. Ti aamoo! la bodaaa hahaha chasy hahaha potatoooo bappleees wiiiii. Hahaha chasy po kass bananaaaa. Aaaaaah hana dul sae hana dul sae poulet tikka masala la bodaaa me want bananaaa! Aaaaaah baboiii. La bodaaa poulet tikka masala bananaaaa belloo! Bee do bee do bee do tatata bala tu tatata bala tu.</p></div><div class=\"cont_der\"><a class=\"boton1 btn btn-primary\" href=\"/#/mapaproductos\">MAPA DE PRODUCTOS</a><br><a class=\"boton2 btn btn-primary\" href=\"/#/contacto\">SOLICITAR INFORMACIÓN</a></div></div><div class=\"breadcumbs\"><h3>GALERÍA DE PASARELAS</h3></div><div class=\"galeria\"></div></div><div ng-include=\"\" src=\"\'app/views/footer.html\'\"></div>");
$templateCache.put("app/views/productos/galeria.html","<div class=\"fondo-galeria\" data-ng-show=\"productos.galeria\"><div class=\"cont-galeria\" data-ng-init=\"productos.fotoactiva = 0\"><button class=\"bt-close\" data-ng-click=\"productos.galeria = false\"></button> <button class=\"nav-galeria prev\" data-ng-click=\"productos.antGal(productos.fotoactiva)\" data-ng-disabled=\"productos.fotoactiva == 0\"></button><div class=\"cont-imag\" data-ng-repeat=\"imagen in productos.galeria\" data-ng-if=\"productos.fotoactiva == imagen.numimg\"><h1 data-ng-bind-html=\"imagen.nombre\">VALLAS MEGACENTER 1</h1><img ng-src=\"{{imagen.ruta}}\"><p data-ng-bind-html=\"imagen.descripcion\">Lorem ipsum dolor sit amet, consectetur piscing elit. Nulla ullamcorper. Nulla ullamcorper a justo imperdiet placerat. Lorem ipsum dolor Lorem ipsum dolor sit amet, consectetur piscing elit amet.</p></div><button class=\"nav-galeria next\" data-ng-click=\"productos.sigGal(productos.fotoactiva)\" data-ng-disabled=\"productos.fotoactiva == productos.cantidadFotos\"></button></div></div>");
$templateCache.put("app/views/productos/informacion.html","<div ng-include=\"\" src=\"\'app/views/header.html\'\"></div><div ng-include=\"\" src=\"\'app/views/breadcrumbs.html\'\"></div><div class=\"pag-info pagina\"><div class=\"gradient\"><h1 class=\"icon-vallas\" data-ng-bind=\"info.producto.alias\"></h1><div class=\"infoMsj\" data-ng-class=\"{enviado: info.mensajeEnviado}\"><div class=\"centerMSJ\"><p class=\"info\">{{info.mensajeform}}</p><a href=\"#/productos\" class=\"bt-celeste\" data-ng-class=\"{ocultar: !info.mensajeEnviado}\">Volver al mapa</a></div></div><input type=\"text\" placeholder=\"Nombre completo\" data-ng-pattern=\"/^[a-zA-Zñáéíóú\\s]*.{3}$/\" class=\"input-formulario\" data-ng-model=\"info.nombre\" required=\"\" data-ng-class=\"{ocultar: info.mensajeEnviado}\"> <label data-ng-class=\"{ocultar: info.mensajeEnviado}\">Nombre completo</label> <input type=\"tel\" placeholder=\"Teléfono\" class=\"input-formulario\" data-ng-model=\"info.telefono\" required=\"\" data-ng-pattern=\"/^[0-9].{6,8}$/\" data-ng-class=\"{ocultar: info.mensajeEnviado}\"> <label data-ng-class=\"{ocultar: info.mensajeEnviado}\">Teléfono</label> <input type=\"email\" placeholder=\"Correo electrónico\" class=\"input-formulario\" data-ng-model=\"info.email\" required=\"\" data-ng-pattern=\'/^(([^<>()[\\]\\\\.,;:\\s@\\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\\"]+)*)|(\\\".+\\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\' data-ng-class=\"{ocultar: info.mensajeEnviado}\"> <label data-ng-class=\"{ocultar: info.mensajeEnviado}\">Correo electrónico</label> <textarea name=\"\" id=\"\" cols=\"30\" rows=\"3\" placeholder=\"Su mensaje...\" class=\"input-formulario\" data-ng-model=\"info.mensaje\" data-ng-pattern=\"/^[a-zA-Zñáéíóú\\s]*.{3}$/\" data-ng-class=\"{ocultar: info.mensajeEnviado}\"></textarea> <label data-ng-class=\"{ocultar: info.mensajeEnviado}\">Mensaje</label><div class=\"cont-captcha\"><div class=\"form-group g-recaptcha\"><div vc-recaptcha=\"\" theme=\"\'light\'\" key=\"info.model.key\" on-create=\"info.setWidgetId(widgetId)\" on-success=\"info.setResponse(response)\" on-expire=\"info.cbExpiration()\"></div></div><div class=\"bt-refresh\" title=\"Recargar captcha\" onclick=\"location.reload();\"></div></div><button ng-click=\"info.enviarSolicitud()\" class=\"bt-celeste\" data-ng-class=\"{ocultar: info.mensajeEnviado}\" data-ng-if=\"info.enableSubmit\">ENVIAR</button></div><div class=\"banner\" style=\"background: url(\'{{info.producto.imagen}}\') no-repeat center;\"></div></div><div ng-include=\"\" src=\"\'app/views/footer.html\'\" class=\"footer-rel\"></div>");
$templateCache.put("app/views/productos/productos.html","<div ng-include=\"\" src=\"\'app/views/header.html\'\"></div><div ng-include=\"\" src=\"\'app/views/subheader.html\'\"></div><div ng-include=\"\" src=\"\'app/views/productos/galeria.html\'\"></div><div class=\"pag-productos pagina\" data-ng-init=\"productos.galeria = false\"><div class=\"mapa\" mapa-height=\"\" data-ng-model=\"productos.mapa\" data-ng-if=\"productos.cargarmapa\"><ng-map id=\"mapa2\" default-style=\"false\" zoom=\"14\" center=\"{{productos.latcenter}}, {{productos.loncenter}}\" styles=\"[{stylers: [{hue: \'#0080ff\'},{saturation: -50},{lightness: -3}]},{featureType: \'road\',elementType: \'geometry\',stylers: [{lightness: -5},{visibility: \'simplified\'}]},{featureType: \'road\',elementType: \'labels\',stylers: [{visibility: \'off\'}]}]\"><info-window id=\"myInfoWindow\" class=\"info-marker\" max-width=\"320\"><div ng-non-bindable=\"\" class=\"info-marker\"><div class=\"info\"><div class=\"desc-mk\"><h3 data-ng-bind=\"productos.selectedCity.alias\"></h3><p><span>Dirección:</span><span class=\"sinestilo\" data-ng-bind-html=\"productos.selectedCity.direccion\"></span></p></div><div class=\"img-mk\"><img data-ng-src=\"{{productos.selectedCity.imagen}}\"></div></div><p data-ng-if=\"productos.selectedCity.activo == 0\">Este producto está en mantenimiento</p><div class=\"botones\"><a class=\"bt-transparente\" data-ng-if=\"productos.selectedCity.galprod\" data-ng-click=\"mostrarGaleria(productos.selectedCity.id);\">VER GALERÍA</a> <a href=\"#/informacion/{{productos.selectedCity.id}}\" class=\"bt-transparente\">SOLICITAR INFORMACIÓN</a></div></div></info-window><marker data-ng-repeat=\"prd in productos.productos\" data-ng-if=\"productos.buscategoria(prd.categoriasproductos_id)\" position=\"{{prd.latitud}},{{prd.longitud}}\" id=\"{{prd.id}}\" on-click=\"productos.showCity(event, prd)\" icon=\"{{productos.buscarIcon(prd)}}\"></marker></ng-map></div></div>");
$templateCache.put("app/views/publicidadhd/publicidadhd.html","<div ng-include=\"\" src=\"\'app/views/header.html\'\"></div><div class=\"contenedor_productos2 container-fluid\"><div class=\"breadcumbs\"><p><b><a href=\"/#/inicio\">Inicio</a> > <a href=\"/#/productos\">Productos</a> > Publicidad HD</b></p></div><div class=\"row\" style=\"height: 100%;\"><div class=\"cont_izq\"><div class=\"titulo_producto\"><div class=\"icono\"><img src=\"app/icons/icono_publicidad_hd.svg\" class=\"icono\" alt=\"\"></div><div class=\"titulo\"><h1>PUBLICIDAD HD</h1></div></div><p>Daa chasy potatoooo underweaaar underweaaar. Tank yuuu! potatoooo bee do bee do bee do uuuhhh uuuhhh belloo! Belloo! me want bananaaa! Pepete hahaha belloo! Chasy bappleees butt tatata bala tu jeje. Ti aamoo! la bodaaa hahaha chasy hahaha potatoooo bappleees wiiiii. Hahaha chasy po kass bananaaaa. Aaaaaah hana dul sae hana dul sae poulet tikka masala la bodaaa me want bananaaa! Aaaaaah baboiii. La bodaaa poulet tikka masala bananaaaa belloo! Bee do bee do bee do tatata bala tu tatata bala tu.</p></div><div class=\"cont_der\"><a class=\"boton1 btn btn-primary\" href=\"/#/mapaproductos\">MAPA DE PRODUCTOS</a><br><a class=\"boton2 btn btn-primary\" href=\"/#/contacto\">SOLICITAR INFORMACIÓN</a></div></div><div class=\"breadcumbs\"><h3>GALERÍA DE PUBLICIDAD HD</h3></div><div class=\"galeria\"></div></div><div ng-include=\"\" src=\"\'app/views/footer.html\'\"></div>");
$templateCache.put("app/views/quienessomos/quienessomos.html","<div ng-include=\"\" src=\"\'app/views/header.html\'\"></div><div ng-include=\"\" src=\"\'app/views/breadcrumbs.html\'\"></div><div class=\"pag-quienes pagina\"><div class=\"hito clearfix\" data-ng-repeat=\"hito in quienes.hitos | orderBy : \'gestion\'\" data-ng-if=\"quienes.hitos100\"><div class=\"c-hito\"><img class=\"img-hito\" data-ng-src=\"{{hito.imagen}}\"></div><div class=\"gestion\"><p data-ng-bind-html=\"hito.gestion\"></p></div><div class=\"c-hito\"><div class=\"cont-tx\"><h1 data-ng-bind-html=\"hito.titulo\"></h1><p data-ng-bind-html=\"hito.texto\"></p></div></div></div></div><div ng-include=\"\" src=\"\'app/views/footer.html\'\" class=\"footer-rel\"></div>");
$templateCache.put("app/views/vallas/vallas.html","<div ng-include=\"\" src=\"\'app/views/header.html\'\"></div><div class=\"contenedor_productos2 container-fluid\"><div class=\"breadcumbs\"><p><b><a href=\"/#/inicio\">Inicio</a> > <a href=\"/#/productos\">Productos</a> > Vallas Publicitarias</b></p></div><div class=\"row\" style=\"height: 100%;\"><div class=\"cont_izq\"><div class=\"titulo_producto\"><div class=\"icono\"><img src=\"app/icons/icono_valla.svg\" class=\"icono\" alt=\"\"></div><div class=\"titulo\"><h1>VALLAS PUBLICITARIAS</h1></div></div><p>Daa chasy potatoooo underweaaar underweaaar. Tank yuuu! potatoooo bee do bee do bee do uuuhhh uuuhhh belloo! Belloo! me want bananaaa! Pepete hahaha belloo! Chasy bappleees butt tatata bala tu jeje. Ti aamoo! la bodaaa hahaha chasy hahaha potatoooo bappleees wiiiii. Hahaha chasy po kass bananaaaa. Aaaaaah hana dul sae hana dul sae poulet tikka masala la bodaaa me want bananaaa! Aaaaaah baboiii. La bodaaa poulet tikka masala bananaaaa belloo! Bee do bee do bee do tatata bala tu tatata bala tu.</p></div><div class=\"cont_der\"><a class=\"boton1 btn btn-primary\" href=\"/#/mapaproductos\">MAPA DE PRODUCTOS</a><br><a class=\"boton2 btn btn-primary\" href=\"/#/contacto\">SOLICITAR INFORMACIÓN</a></div></div><div class=\"breadcumbs\"><h3>GALERÍA DE VALLAS PUBLICITARIAS</h3></div><div class=\"galeria\"></div></div><div ng-include=\"\" src=\"\'app/views/footer.html\'\"></div>");}]);